export default {
  "dashboard.analysis.total-sales": "รายได้รวม (GGR)",
  "dashboard.analysis.gross-gaming-revenue": "รายได้รวมจากเกม",
  "dashboard.analysis.visits": "ล็อคอินทั้งหมดวันนี้",
  "dashboard.analysis.new-sites": "จำนวนล็อคอินทั้งหมด",
  "dashboard.analysis.daily-visits": "ล็อคอิน/วัน",
  "dashboard.analysis.active-players": "ผู้เล่นที่ใช้งาน",
  "dashboard.analysis.daily-players": "ผู้เล่น/วัน",
  "dashboard.analysis.weekly-comparison": "รายสัปดาห์",
  "dashboard.analysis.daily-comparison": "GGR/วัน",
  "dashboard.analysis.daily-sales": "GGR/วัน",
  "dashboard.analysis.turnover": "ยอดเดิมพันรวม",
  "dashboard.analysis.week-on-week": "เปลี่ยนแปลง WoW",
  "dashboard.analysis.day-on-day": "เปลี่ยนแปลง DoD",
  "dashboard.analysis.payments": "เจ้าของระบบที่ใช้งาน",
  "dashboard.analysis.operational-effect": "ประสิทธิภาพระบบ",
  "dashboard.analysis.indicator-introduction": "คำอธิบายตัวชี้วัด",
  "fund.message.topup.minAmountWarning": "จำนวนเงินขั้นต่ำไม่เพียงพอ",
  "fund.message.topup.success": "โอนสำเร็จ",
  "fund.table.column.date": "วันที่",
  "fund.table.column.type": "ประเภท",
  "fund.table.column.amount": "จำนวนเงิน",
  "fund.table.column.status": "สถานะ",
  "fund.table.column.order": "คำสั่งซื้อ",
  "fund.table.column.description": "รายละเอียด",
  "fund.tab.vault.title": "Vault",
  "fund.topup.form.selectCrypto": "เลือกสกุลเงินดิจิทัลที่โอน",
  "fund.topup.form.amountLabel": "จำนวนเงินที่โอน",
  "fund.topup.form.minAmountHint": "ขั้นต่ำ {amount} {currency}",
  "fund.topup.form.submit": "โอน {amount}",
  "fund.topup.form.exchangeNotice": "สกุลเงิน {crypto} ของคุณจะถูกแปลงเป็น USDT ตามอัตราตลาดปัจจุบันโดยอัตโนมัติ",
  "fund.topup.form.finalCurrency": "เงินทุนทั้งหมดจะถูกบันทึกเป็น USDT",
  "fund.tab.asset.title": "คลังเงิน",
  "fund.balance.pending.label": "รอดำเนินการ",
  "pages.fund.purchase.disabled": "การซื้อแพ็กเกจถูกปิดใช้งาน",
  "pages.fund.purchase.disabledMessage": "ฟีเจอร์การซื้อแพ็กเกจถูกลบออกแล้ว กรุณาติดต่อฝ่ายสนับสนุนสำหรับคำขอเงินทุน",
  "pages.fund.purchase.close": "ปิด",
  "fund.transactions.title": "ประวัติรายการเงิน",
  "dashboard.analysis.ggr-by-provider": "การเติบโตของลูกค้า (Owners)",
  "dashboard.analysis.visits-ranking": "อันดับยอดเข้าชม",
  "dashboard.analysis.ggr-by-provider-ranking": "อันดับเจ้าของระบบสูงสุด",
  "dashboard.analysis.all-day": "วันนี้",
  "dashboard.analysis.all-week": "สัปดาห์นี้",
  "dashboard.analysis.all-month": "เดือนนี้",
  "dashboard.analysis.all-year": "ปีนี้",
  "dashboard.analysis.today": "วันนี้",
  "dashboard.analysis.week": "สัปดาห์",
  "dashboard.analysis.month": "เดือน",
  "dashboard.analysis.year": "ปี",
  "pages.org.hierarchy.site": "House",
  "dashboard.analysis.online-top-search": "ค่ายเกมยอดนิยม (Top Vendors)",
  "dashboard.analysis.search-users": "จำนวนเกมทั้งหมด",
  "dashboard.analysis.per-capita-search": "การนำเข้าเกมเฉลี่ย",
  "dashboard.analysis.table.rank": "อันดับ",
  "dashboard.analysis.table.search-keyword": "ชื่อค่ายเกม",
  "dashboard.analysis.table.users": "จำนวนเกม",
  "dashboard.analysis.table.weekly-range": "อัตราการเติบโต",
  "dashboard.analysis.the-proportion-of-sales": "สัดส่วนแพลตฟอร์ม",
  "dashboard.analysis.channel.all": "สถานะเว็บ (Stages)",
  "dashboard.analysis.channel.online": "ประเภทเกม (Types)",
  "dashboard.analysis.channel.stores": "สกุลเงิน (Currencies)",
  "monitor.trading.title": "ธุรกรรม",
  "monitor.trading.total-turnover": "ยอดเดิมพันรวมวันนี้",
  "monitor.trading.target-completion": "ความสำเร็จตามเป้าหมาย",
  "monitor.trading.time-remaining": "เวลาที่เหลือ (ปิดยอดวัน)",
  "monitor.trading.live-tps": "ความเร็วธุรกรรม (TPS)",
  "monitor.trend.traffic": "แนวโน้มการใช้งาน",
  "monitor.rtp.title": "อัตราจ่ายคืนสด (Live RTP)",
  "monitor.rtp.status.profitable": "กำไรปกติ",
  "monitor.rtp.status.risk": "ความเสี่ยงสูง",
  "monitor.rtp.status.critical": "ขาดทุนวิกฤต (แตกหนัก)",
  "monitor.category.proportion": "สัดส่วนประเภทเกม",
  "monitor.category.top-ranks": "จัดอันดับ",
  "monitor.category.none": "ทั้งหมด",
  "monitor.category.electronic": "อิเล็กทรอนิกส์",
  "monitor.category.slot": "สล็อต",
  "monitor.category.table": "เกมโต๊ะ",
  "monitor.category.live": "คาสิโนสด",
  "monitor.category.lottery": "หวย",
  "monitor.category.fish": "เกมยิงปลา",
  "monitor.category.arcade": "อาเขต",
  "monitor.category.sport": "กีฬา",
  "monitor.category.esport": "อีสปอร์ต",
  "vendor.ggr.card.category.none": "ทั้งหมด",
  "vendor.ggr.card.category.electronic": "อิเล็กทรอนิกส์",
  "vendor.ggr.card.category.slot": "สล็อต",
  "vendor.ggr.card.category.table": "เกมโต๊ะ",
  "vendor.ggr.card.category.live": "คาสิโนสด",
  "vendor.ggr.card.category.lottery": "หวย",
  "vendor.ggr.card.category.fish": "เกมยิงปลา",
  "vendor.ggr.card.category.arcade": "อาเขต",
  "vendor.ggr.card.category.sport": "กีฬา",
  "vendor.ggr.card.category.blockchain": "บล็อกเชน",
  "vendor.ggr.card.category.esport": "อีสปอร์ต",
  "pages.header.switchingSite": "กำลังเปลี่ยนไซต์...",
  "dashboard.analysis.offline-data": "คุณภาพเจ้าของระบบ",
  "dashboard.analysis.conversion-rate": "อัตราเปิดใช้งานจริง (CVR)",
  "pages.layouts.userLayout.title": "Version 1.0.0",
  "pages.login.accountLogin.tab": "พื้นที่เมมเบอร์",
  "pages.login.accountLogin.errorMessage": "Incorrect username/password(admin/ant.design)",
  "pages.login.failure": "Login failed, please try again!",
  "pages.login.username.placeholder": "ไอดีเมมเบอร์ / ชื่อผู้ใช้",
  "pages.login.username.required": "โปรดป้อนชื่อผู้ใช้ของคุณ!",
  "pages.login.password.placeholder": "รหัสผ่าน",
  "pages.login.password.required": "โปรดป้อนรหัสผ่านของคุณ!",
  "pages.login.totp.placeholder": "2FA Authenticator",
  "pages.login.hubOwnerLogin.tab": "Gateway Owner Login",
  "pages.login.phoneLogin.errorMessage": "Verification Code Error",
  "pages.login.phoneNumber.placeholder": "Phone Number",
  "pages.login.phoneNumber.required": "Please input your phone number!",
  "pages.login.phoneNumber.invalid": "Phone number is invalid!",
  "pages.login.captcha.placeholder": "Verification Code",
  "pages.login.captcha.required": "Please input verification code!",
  "pages.login.phoneLogin.getVerificationCode": "Get Code",
  "pages.getCaptchaSecondText": "sec(s)",
  "pages.login.rememberMe": "Remember me",
  "pages.login.forgotPassword": "Forgot Password ?",
  "pages.login.submit": "Login",
  "pages.login.loginWith": "Login with :",
  "pages.login.registerAccount": "Register Account",
  "pages.welcome.link": "Welcome",
  "pages.welcome.alertMessage": "Faster and stronger heavy-duty components have been released.",
  "pages.404.subTitle": "Sorry, the page you visited does not exist.",
  "pages.404.buttonText": "Back Home",
  "pages.admin.subPage.title": "This page can only be viewed by Admin",
  "pages.admin.subPage.alertMessage": "Umi ui is now released, welcome to use npm run ui to start the experience.",
  "pages.searchTable.createForm.newRule": "New Rule",
  "pages.searchTable.search": "ค้นหา",
  "pages.searchTable.reset": "เคลียร์",
  "pages.searchTable.updateForm.ruleConfig": "Rule configuration",
  "pages.searchTable.updateForm.basicConfig": "Basic Information",
  "pages.searchTable.updateForm.ruleName.nameLabel": "Rule Name",
  "pages.searchTable.updateForm.ruleName.nameRules": "Please enter the rule name!",
  "pages.searchTable.updateForm.ruleDesc.descLabel": "Rule Description",
  "pages.searchTable.updateForm.ruleDesc.descPlaceholder": "Please enter at least five characters",
  "pages.searchTable.updateForm.ruleDesc.descRules": "Please enter a rule description of at least five characters!",
  "pages.searchTable.updateForm.ruleProps.title": "Rule Title",
  "pages.searchTable.updateForm.object": "Monitoring Object",
  "pages.searchTable.updateForm.ruleProps.templateLabel": "Rule Template",
  "pages.searchTable.updateForm.ruleProps.typeLabel": "Rule Type",
  "pages.searchTable.updateForm.schedulingPeriod.title": "Set Scheduling Period",
  "pages.searchTable.updateForm.schedulingPeriod.timeLabel": "Starting Time",
  "pages.searchTable.updateForm.schedulingPeriod.timeRules": "Please choose a start time!",
  "pages.searchTable.titleDesc": "Description",
  "pages.searchTable.ruleName": "Rule name is required",
  "pages.searchTable.titleCallNo": "Number of Service Calls",
  "pages.searchTable.titleStatus": "Status",
  "pages.searchTable.nameStatus.default": "default",
  "pages.searchTable.nameStatus.running": "running",
  "pages.searchTable.nameStatus.online": "online",
  "pages.searchTable.nameStatus.abnormal": "abnormal",
  "pages.searchTable.titleUpdatedAt": "Last Scheduled at",
  "pages.searchTable.exception": "Please enter the reason for the exception!",
  "pages.searchTable.titleOption": "Option",
  "pages.searchTable.config": "Configuration",
  "pages.searchTable.subscribeAlert": "Subscribe to alerts",
  "pages.searchTable.title": "ITABLES",
  "pages.searchTable.new": "New",
  "pages.searchTable.chosen": "chosen",
  "pages.searchTable.item": "item",
  "pages.searchTable.totalServiceCalls": "Total Number of Service Calls",
  "pages.searchTable.tenThousand": "0000",
  "pages.searchTable.id": "ไอดี",
  "pages.searchTable.balance": "ยอดเงิน",
  "pages.searchTable.batchDeletion": "Batch Deletion",
  "pages.searchTable.batchApproval": "Batch Approval",
  "pages.player.list": "รายชื่อผู้เล่น",
  "pages.player.list.title": "รายชื่อผู้เล่น",
  "pages.player.list.clickToVerify": "คลิกเพื่อยืนยันตัวตน",
  "pages.player.list.selectedCount": "เลือก {count} รายการ",
  "pages.player.resendVerification.title": "ส่ง OTP ยืนยันตัวตนอีกครั้ง",
  "pages.player.resendVerification.confirm": "ส่ง OTP ให้ {count} ท่าน",
  "pages.player.resendVerification.successCount": "ส่ง OTP ให้ผู้เล่น {count} ท่านสำเร็จ",
  "pages.player.resendVerification.partialSuccess": "ส่งสำเร็จ {sent}/{total} — ล้มเหลว {failed}",
  "pages.player.resendVerification.alreadyVerifiedWarning": "มีผู้เล่น {count} ท่านที่ยืนยันตัวตนแล้ว — จะถูกข้าม",
  "pages.player.resendVerification.allVerified": "ผู้เล่นที่เลือกทั้งหมดได้ยืนยันตัวตนเรียบร้อยแล้ว",
  "pages.player.resendVerification.willSend": "จะส่งให้",
  "pages.player.resendVerification.willSkip": "จะข้าม (ยืนยันแล้ว)",
  "pages.player.resendVerification.singleHint": "OTP ใหม่จะถูกส่งผ่าน SMS ไปยังเบอร์นี้",
  "pages.player.drawer.resendOtp": "ส่ง OTP อีกครั้ง",
  "pages.player.list.id": "ไอดี",
  "pages.player.list.playerInfo": "ข้อมูลผู้เล่น",
  "pages.player.list.balance": "ยอดเงิน",
  "pages.player.drawer.phoneRequired": "กรุณากรอกเบอร์",
  "pages.player.list.ggr": "GGR",
  "pages.player.list.affiliate": "แอฟฟิลิเอท",
  "pages.player.list.createdAt": "วันที่สร้าง",
  "pages.player.list.actions": "การดำเนินการ",
  "pages.player.list.transfer": "แก้ไขบัญชีธนาคาร",
  "pages.player.list.sendSMS": "ส่งข้อความ",
  "pages.player.list.delete": "ลบ",
  "pages.player.list.verified_phone": "ยืนยันเบอร์โทรศัพท์",
  "pages.player.list.ggrTooltip": "รายได้จากการเล่นเกมรวม (ยอดเดิมพันรวม - ยอดชนะรวม)",
  "pages.player.list.deleteConfirm": "ยืนยันการลบ?",
  "pages.player.list.total": "ทั้งหมด {total} รายการ",
  "pages.player.list.unverified": "ยังไม่ได้ยืนยัน",
  "pages.player.list.payout_account_not_set": "ยังไม่ได้ตั้งค่าบัญชีธนาคาร",
  "pages.player.list.verified": "ยืนยันแล้ว",
  'pages.player.transfer.bank': 'บัญชีรับเงินผู้เล่น',
  "pages.player.list.resendVerify": "ส่ง OTP อีกครั้ง",
  "pages.player.new": "ผู้เล่นใหม่",
  "pages.player.register": "ลงทะเบียนผู้เล่นใหม่",
  "pages.player.modal.title": "ลงทะเบียนผู้เล่นใหม่",
  "pages.player.modal.tryRefreshSitesFirst": "ลองรีเฟรชเว็บไซต์ก่อน",
  "pages.player.modal.site": "เว็บไซต์",
  "pages.player.modal.currency": "สกุลเงิน",
  "pages.player.modal.close": "ปิด",
  "pages.player.modal.register": "ลงทะเบียน",
  "pages.player.modal.verify": "ยืนยันผู้เล่นใหม่",
  "pages.player.modal.back": "กลับ",
  "pages.player.modal.verify.otp": "ยืนยันผู้เล่นใหม่",
  "pages.player.modal.refreshSites": "รีเฟรช",
  "pages.player.modal.cancel": "ปิด",
  "pages.header.selectSite": "ไซต์",
  "pages.player.modal.verification.message": "ยืนยันผู้เล่น",
  "pages.player.sendMessage.title": "ส่งข้อความถึงผู้เล่น",
  "pages.player.sendMessage.channel": "ช่องทาง",
  "pages.player.sendMessage.smsHint": "ส่งผ่าน SMS ไปยังเบอร์ {phone}",
  "pages.player.sendMessage.messageRequired": "โปรดป้อนข้อความของคุณ",
  "pages.player.sendMessage.smsLimit": "สูงสุด 160 ตัวอักษรต่อ SMS",
  "pages.player.sendMessage.placeholder": "ระบุข้อความของคุณที่นี่...",
  "pages.player.sendMessage.message": "ข้อความ",
  "pages.player.sendMessage.send": "ส่งข้อความ",
  "pages.common.save": "บันทึก",
  "pages.common.create": "สร้าง",
  "pages.common.cancel": "ยกเลิก",
  "pages.common.delete": "ลบ",
  "pages.player.modal.passwordInfo": "ข้อมูลเกี่ยวกับรหัสผ่านของผู้เล่น",
  "pages.player.modal.passwordInfoSubtitle": "รหัสผ่านถูกสร้างขึ้นอัตโนมัติตามหมายเลขโทรศัพท์ของผู้เล่นและจะถูกส่งไปยังหมายเลขโทรศัพท์ของผู้เล่น",
  "pages.player.drawer.currentSite": "ไซต์ปัจจุบัน",
  "pages.profile.basic.time": "เวลา",
  "pages.profile.basic.rate": "ความคืบหน้าปัจจุบัน",
  "pages.profile.basic.status": "สถานะ",
  "pages.profile.basic.status.success": "สำเร็จ",
  "pages.profile.basic.status.processing": "กำลังดำเนินการ",
  "pages.profile.basic.operator": "ไอดีผู้ดำเนินการ",
  "pages.profile.basic.cost": "ระยะเวลาที่ใช้",
  "pages.profile.basic.total": "รวมทั้งหมด",
  "pages.profile.basic.good.id": "รหัสสินค้า",
  "pages.profile.basic.good.name": "ชื่อสินค้า",
  "pages.profile.basic.good.barcode": "บาร์โค้ดสินค้า",
  "pages.profile.basic.good.price": "ราคาต่อหน่วย",
  "pages.profile.basic.good.num": "จำนวน (ชิ้น)",
  "pages.profile.basic.good.amount": "จำนวนเงิน",
  "pages.profile.basic.refund": "คำขอคืนเงิน",
  "pages.profile.basic.pickup.number": "หมายเลขรับสินค้า",
  "pages.profile.basic.pickup.status": "สถานะ",
  "pages.profile.basic.pickup.status.picked": "รับสินค้าแล้ว",
  "pages.profile.basic.sale.number": "หมายเลขการขาย",
  "pages.profile.basic.child.order": "ใบสั่งซื้อย่อย",
  "pages.profile.basic.user.info": "ข้อมูลผู้ใช้งาน",
  "pages.profile.basic.user.name": "ชื่อผู้ใช้งาน",
  "pages.profile.basic.user.phone": "เบอร์โทรศัพท์ติดต่อ",
  "pages.profile.basic.user.express": "ขนส่งที่ใช้บ่อย",
  "pages.profile.basic.user.address": "ที่อยู่รับสินค้า",
  "pages.profile.basic.user.remark": "หมายเหตุ",
  "pages.profile.basic.user.remark.none": "ไม่มี",
  "pages.profile.basic.total.id": "รวมทั้งหมด",
  "pages.profile.basic.user.name.val": "ฟู เซียวเซียว",
  "pages.profile.basic.user.express.val": "คลังสินค้าเกินเหนียว",
  "pages.profile.basic.user.address.val": "เลขที่ 18 ถนนหมื่นถม เขตซีหู เมืองหังโจว มณฑลเจ้อเจียง",
  "pages.profile.basic.return.goods": "สินค้าคืน",
  "pages.profile.basic.return.progress": "ความคืบหน้าการคืนสินค้า",
  "pages.profile.advanced.op1": "จัดการ 1",
  "pages.profile.advanced.op2": "จัดการ 2",
  "pages.profile.advanced.op3": "จัดการ 3",
  "pages.profile.advanced.main.op": "ดำเนินการหลัก",
  "pages.profile.advanced.opt1": "ตัวเลือก 1",
  "pages.profile.advanced.opt2": "ตัวเลือก 2",
  "pages.profile.advanced.opt3": "ตัวเลือก 3",
  "pages.profile.advanced.log1": "บันทึกการดำเนินการ 1",
  "pages.profile.advanced.log2": "บันทึกการดำเนินการ 2",
  "pages.profile.advanced.log3": "บันทึกการดำเนินการ 3",
  "pages.profile.advanced.type": "ประเภทการดำเนินการ",
  "pages.profile.advanced.operator": "ผู้ดำเนินการ",
  "pages.profile.advanced.result": "ผลการดำเนินการ",
  "pages.profile.advanced.result.success": "สำเร็จ",
  "pages.profile.advanced.result.reject": "ปฏิเสธ",
  "pages.profile.advanced.time": "เวลาดำเนินการ",
  "pages.profile.advanced.memo": "หมายเหตุ",
  "pages.profile.advanced.status": "สถานะ",
  "pages.profile.advanced.status.pending": "รอการอนุมัติ",
  "pages.profile.advanced.amount": "จำนวนเงินในคำสั่งซื้อ",
  "pages.profile.advanced.creator": "ผู้สร้าง",
  "pages.profile.advanced.product": "สินค้าที่สั่งซื้อ",
  "pages.profile.advanced.create.time": "เวลาที่สร้าง",
  "pages.profile.advanced.rel.doc": "เอกสารที่เกี่ยวข้อง",
  "pages.profile.advanced.effect.date": "วันที่เริ่มมีผล",
  "pages.profile.advanced.remind": "โปรดยืนยันภายในสองวันทำการ",
  "pages.profile.advanced.urge": "เร่งดำเนินการ",
  "pages.profile.advanced.no.response": "ไม่มีการตอบสนอง",
  "pages.profile.advanced.cost": "เวลาที่ใช้: ",
  "pages.profile.advanced.hours": " ชั่วโมง ",
  "pages.profile.advanced.minutes": " นาที",
  "pages.profile.advanced.detail": "รายละเอียด",
  "pages.profile.advanced.rule": "กฎ",
  "pages.profile.advanced.order.no": "หมายเลขคำสั่งซื้อ: ",
  "pages.profile.advanced.flow": "ลำดับขั้นตอน",
  "pages.profile.advanced.step1": "สร้างโครงการ",
  "pages.profile.advanced.step2": "การตรวจสอบเบื้องต้นจากแผนก",
  "pages.profile.advanced.step3": "การตรวจสอบทางการเงิน",
  "pages.profile.advanced.step4": "เสร็จสิ้น",
  "pages.profile.advanced.user.info": "ข้อมูลผู้ใช้งาน",
  "pages.profile.advanced.user.name": "ชื่อผู้ใช้งาน",
  "pages.profile.advanced.user.card": "หมายเลขบัตรสมาชิก",
  "pages.profile.advanced.user.id": "บัตรประชาชน",
  "pages.profile.advanced.user.phone": "ข้อมูลติดต่อ",
  "pages.profile.advanced.user.address": "ที่อยู่ติดต่อ",
  "pages.profile.advanced.info.group": "กลุ่มข้อมูล",
  "pages.profile.advanced.data": "ข้อมูลบางอย่าง",
  "pages.profile.advanced.update.time": "เวลาที่อัปเดตข้อมูล",
  "pages.profile.advanced.data.desc": "คำอธิบายข้อมูล",
  "pages.profile.advanced.multi.group": "กลุ่มข้อมูลหลายระดับ",
  "pages.profile.advanced.group.name": "ชื่อกลุ่ม",
  "pages.profile.advanced.manager": "ผู้รับผิดชอบ",
  "pages.profile.advanced.role": "รหัสบทบาท",
  "pages.profile.advanced.dept": "แผนกที่สังกัด",
  "pages.profile.advanced.expire": "เวลาหมดอายุ",
  "pages.profile.advanced.desc": "คำอธิบาย",
  "pages.profile.advanced.scientific.name": "ชื่อทางวิทยาศาสตร์",
  "pages.profile.advanced.call.records": "บันทึกการโทรย้อนหลัง 6 เดือน",
  "pages.profile.advanced.creator.val": "ฉวี่ ลี่ลี่",
  "pages.profile.advanced.product.val": "บริการ XX",
  "pages.profile.advanced.username.zhou": "โจว เหมาเหมา",
  "pages.profile.advanced.username.wu": "อู๋ เจียห่าว",
  "pages.profile.advanced.username.lin": "หลิน ตงตง",
  "pages.profile.advanced.user.name.val": "ฟู เซียวเซียว",
  "pages.profile.advanced.user.address.val": "ฉวี่ ลี่ลี่ 18100000000 สี่แยกถนนหวงกูซานและถนนกงจวง เขตซีหู เมืองหังโจว มณฑลเจ้อเจียง",
  "pages.profile.advanced.dept.val": "บริษัท XX - แผนก YY",
  "pages.profile.advanced.desc.val": "คำอธิบายนี้ยาวมากยาวมากยาวมากยาวมาก...",
  "pages.profile.advanced.scientific.name.val": "Citrullus lanatus (Thunb.) Matsum. et Nakai เป็นพืชเถาเลื้อยปีเดียว ลำต้นและกิ่งก้านหนาและมีสันที่เห็นได้ชัดเจน มือเกาะมีความหนา...",
  "pages.management.transactions.betAmount": "การเดิมพัน",
  "pages.management.transactions.payoutAmount": "การจ่ายเงิน",
  "pages.management.transactions.targetCompletion": "ความสำเร็จตามเป้าหมาย",
  "pages.management.transactions.timeRemaining": "เวลาที่เหลือ (ปิดยอดวัน)",
  "pages.management.transactions.liveTps": "ความเร็วธุรกรรม (TPS)",
  "pages.management.transactions.reqPerSec": "ร้องขอ/วินาที",
  "pages.management.transactions.total": "ทั้งหมด {total}",
  "pages.player.transfer.title": "จัดการเครดิต",
  "pages.player.transfer.siteBalanceError": "ไม่สามารถตรวจสอบยอดเงินของไซต์ได้ ยกเลิกรายการ",
  "pages.player.transfer.insufficientSiteBalance": "ยอดเงินของไซต์ไม่เพียงพอ! ไซต์มีเพียง {balance}",
  "pages.player.transfer.insufficientPlayerBalance": "ยอดเงินของผู้เล่นไม่เพียงพอ! ผู้เล่นมีเพียง {balance}",
  "pages.player.transfer.success": "ทำรายการสำเร็จ",
  "pages.player.transfer.failed": "ทำรายการล้มเหลว",
  "pages.player.transfer.walletContext": "ข้อมูลกระเป๋า",
  "pages.player.transfer.player": "ผู้เล่น",
  "pages.player.transfer.currentPlayerBalance": "ยอดเงินผู้เล่นปัจจุบัน",
  "pages.player.transfer.siteBalance": "ยอดเงินของไซต์ (House)",
  "pages.player.transfer.sitePlayersBalance": "ยอดเงินผู้เล่นรวม (ทั้งหมด)",
  "pages.player.transfer.transactionType": "ประเภทรายการ",
  "pages.player.transfer.deposit": "ฝาก (เติมให้ผู้เล่น)",
  "pages.player.transfer.withdraw": "ถอน (ดึงจากผู้เล่น)",
  "pages.player.transfer.amount": "จำนวนเงิน",
  "pages.player.transfer.amountRequired": "จำนวนเงินต้องมากกว่า 0",
  "pages.player.transfer.remark": "หมายเหตุ",
  "pages.player.transfer.remarkPlaceholder": "ระบุหมายเหตุ",
  "pages.player.drawer.title": "ลงทะเบียนผู้เล่นใหม่",
  "pages.player.drawer.sessionExpired": "เซสชันการลงทะเบียนหมดอายุ กรุณาลองใหม่อีกครั้ง",
  "pages.player.drawer.createSuccess": "ยืนยันตัวตนและสร้างผู้เล่นเรียบร้อยแล้ว!",
  "pages.player.drawer.verifyFailed": "การยืนยันตัวตนล้มเหลว",
  "pages.player.drawer.required": "จำเป็นต้องระบุข้อมูลนี้",
  "pages.player.drawer.step.accountInfo": "ข้อมูลบัญชี",
  "pages.player.drawer.otpSent": "ส่งรหัส OTP เรียบร้อยแล้ว",
  "pages.player.drawer.regFailed": "การลงทะเบียนล้มเหลว",
  "pages.player.drawer.siteSelection": "เลือกไซต์",
  "pages.player.drawer.selectSite": "เลือกไซต์",
  "pages.player.drawer.playerDetails": "รายละเอียดผู้เล่น",
  "pages.player.drawer.nickname": "ชื่อเล่น",
  "pages.player.drawer.nicknamePlaceholder": "ชื่อที่ใช้แสดง",
  "pages.player.drawer.phoneNumber": "เบอร์โทรศัพท์",
  "pages.player.drawer.invalidPhone": "รูปแบบเบอร์โทรศัพท์ไม่ถูกต้อง",
  "pages.player.drawer.countryCode": "รหัสประเทศ",
  "pages.player.drawer.step.verification": "การยืนยันตัวตน",
  "pages.player.drawer.verifyTitle": "ยืนยันเบอร์โทรศัพท์มือถือ",
  "pages.player.drawer.verifySubtitle": "กรุณากรอกรหัส 6 หลักที่ส่งไปยัง {phone}",
  "pages.player.drawer.otpLength": "ต้องระบุตัวเลข 6 หลัก",
  "pages.player.drawer.otpRequired": "กรุณากรอกรหัส OTP",
  "pages.player.drawer.otpLengthError": "รหัส OTP ต้องมี 6 หลัก",
  "pages.player.drawer.otpTitle": "รหัสยืนยัน 6 หลัก",
  "component.siteSelector.refresh": "refresh",
  "component.siteSelector.playerIdentifier": "เลือกผู้เล่น",
  "component.siteSelector.enterPlayer": "enterPlayer",
  "pages.controlCenter.title": "ศูนย์ควบคุม",
  "pages.controlCenter.description": "จัดการบริการ AI และการจัดสรรทรัพยากรของคุณ",
  "pages.controlCenter.mode": "{mode}",
  "pages.controlCenter.sandbox": "Sandbox",
  "pages.controlCenter.seamless": "Seamless",
  "pages.controlCenter.syncHubs": "ซิงค์ฮับทั้งหมด",
  "pages.controlCenter.saveConfig": "บันทึกการตั้งค่า",
  "pages.controlCenter.balance": "มูลค่าพอร์ต",
  "pages.controlCenter.site_balance": "มูลค่าเฮ้าส์",
  "pages.controlCenter.site_balance_virtual_complimentary": "จำลอง",
  "pages.controlCenter.bussinessRevenueBalance": "มูลค่าของธุรกิจ",
  "pages.controlCenter.creditType": "ประเภทเครดิต",
  "pages.game.badges.new": "New",
  "pages.game.badges.top-rated": "Top Rated",
  "pages.game.badges.hot": "Hot",
  "pages.game.edit": "Update Game",
  "pages.controlCenter.activeHubs": "ผู้ให้บริการที่ร่วมงานอยู่",
  "pages.controlCenter.online": "ออนไลน์",
  "pages.controlCenter.ownerName": "แอดมิน",
  "pages.controlCenter.id": "ไอดี",
  "pages.controlCenter.memberStatus": "สภาพแวดล้อม",
  "pages.controlCenter.ownerNotFound": "ไม่พบข้อมูลโครงการ",
  "pages.controlCenter.configSaved": "บันทึกการตั้งค่าแล้ว",
  "pages.controlCenter.syncFailed": "การขอซิงค์ฮับล้มเหลว",
  "pages.controlCenter.noHubsFound": "ไม่พบฮับที่จะซิงค์",
  "pages.controlCenter.syncAccepted": "รับคำขอซิงค์ฮับแล้ว",
  "pages.controlCenter.robots.dazing.title": "DazingLottie - หายใจ + กระพริบตา",
  "pages.controlCenter.robots.dazing.desc": "ใช้ไลบรารีแอนิเมชัน Lottie เพื่อแสดงผลเอฟเฟกต์การหายใจและกระพริบตา",
  "pages.controlCenter.robots.thinking.title": "ThinkingLottie - กระพริบตา + วิ่ง",
  "pages.controlCenter.robots.thinking.desc": "ใช้ไลบรารีแอนิเมชัน Lottie เพื่อแสดงผลเอฟเฟกต์การกระพริบตาและวิ่ง",
  "pages.controlCenter.robots.bouncing.title": "BouncingLottie - กระโดด",
  "pages.controlCenter.robots.bouncing.desc": "ใช้ไลบรารีแอนิเมชัน Lottie เพื่อแสดงผลเอฟเฟกต์การกระโดด",
  "pages.controlCenter.robots.blowing.title": "BlowingWindLottie - ลมเป่า",
  "pages.controlCenter.robots.blowing.desc": "ใช้ไลบรารีแอนิเมชัน Lottie เพื่อแสดงผลเอฟเฟกต์ลมเป่า",
  "pages.controlCenter.robots.peek.title": "PeekLottie - แอบดู",
  "pages.controlCenter.robots.peek.desc": "ใช้ไลบรารีแอนิเมชัน Lottie เพื่อแสดงผลเอฟเฟกต์การแอบดู",
  "pages.xudo.profile": "ข้อมูลผู้ใช้",
  "pages.xudo.xhub.search": "ค้นหา",
  "pages.xudo.xhub.reset": "รีเซ็ต",
  "pages.xudo.xhub.searchPlaceholder": "ค้นหา {dataIndex}",
  "pages.xudo.xhub.healthy": "ปกติ",
  "pages.xudo.xhub.selectItems": "โปรดเลือกรายการที่ต้องการลบ",
  "pages.xudo.game.id": "ไอดี",
  "pages.xudo.game.gameCode": "รหัสเกม",
  "pages.xudo.game.vendorId": "ไอดีผู้ให้บริการ",
  "pages.xudo.game.category": "ประเภท",
  "pages.xudo.game.icons": "ไอคอน",
  "pages.xudo.game.maintenanceAt": "เวลาปิดปรับปรุง",
  "pages.xudo.game.maintenanceAnnouncement": "ประกาศปิดปรับปรุง",
  "pages.xudo.game.createdAt": "สร้างเมื่อ",
  "pages.xudo.game.updatedAt": "อัปเดตเมื่อ",
  "pages.xudo.game.defaultConfig": "การกำหนดค่าเริ่มต้น",
  "pages.xudo.game.launchFailed": "เริ่มเกมไม่สำเร็จ",
  "pages.xudo.game.launching": "กำลังเริ่ม...",
  "pages.xudo.game.selectSiteTitle": "เลือกไซต์เพื่อทดสอบเกม",
  "pages.xudo.xhub.form.select": "เลือก",
  "pages.xudo.xhub.form.selectCountry": "โปรดเลือกประเทศ",
  "pages.xudo.xhub.form.standardServerApis": "Standard Server API",
  "pages.xudo.xhub.form.apiEndpointTooltip": "จุดเชื่อมต่อ API หลัก",
  "pages.xudo.xhub.form.igmHubSeamless": "IGM Gateway Seamless",
  "pages.xudo.xhub.form.seamlessApis": "Seamless API",
  "pages.xudo.xhub.form.healthCheckPath": "เส้นทางตรวจสอบสถานะ",
  "pages.xudo.xhub.form.whitelistCidrs": "รายการขาว CIDR สำหรับ Callback",
  "pages.xudo.xhub.form.cidrsTooltip": "ช่วง IP ที่อนุญาตให้ Callback",
  "pages.xudo.xhub.form.rawConnectionConfig": "การกำหนดค่าการเชื่อมต่อดิบ",
  "pages.xudo.close": "ปิด",
  "pages.xudo.total": "ทั้งหมด {total} รายการ",
  "pages.games.online": "ออนไลน์",
  "pages.games.maintenanceStatus": "ปรับปรุง",
  "pages.games.play": "เล่น",
  "pages.vendor.title": "รายการค่ายเกม",
  "pages.vendor.new": "เพิ่มค่ายเกมใหม่",
  "pages.vendor.vendor": "ค่ายเกม",
  "pages.vendor.category": "ประเภท",
  "pages.vendor.code": "รหัส",
  "pages.vendor.gateway_id": "รหัสฮับ",
  "pages.vendor.status": "สถานะ",
  "pages.vendor.status.sandbox": "แซนด์บ็อกซ์",
  "pages.vendor.status.production": "โปรดักชัน",
  "pages.vendor.status.ban": "แบน",
  "pages.vendor.status.maintenance": "ปรับปรุง",
  "pages.vendor.updatedAt": "อัปเดตเมื่อ",
  "pages.vendor.operating": "จัดการ",
  "pages.vendor.codeRequired": "จำเป็นต้องระบุรหัสค่ายเกม",
  "pages.vendor.codeLabel": "รหัสค่ายเกม",
  "pages.vendor.hubIdRequired": "จำเป็นต้องระบุรหัสฮับ",
  "pages.vendor.hubIdLabel": "รหัสฮับ",
  "pages.vendor.statusLabel": "สถานะ",
  "pages.vendor.currencies": "สกุลเงินที่รองรับ",
  "pages.vendor.configSupported": "รองรับการตั้งค่า",
  "pages.vendor.yes": "ใช่",
  "pages.vendor.no": "ไม่",
  "pages.vendor.localizedLabels": "ป้ายกำกับแปลภาษา",
  "pages.vendor.defaultSettings": "การตั้งค่าเริ่มต้น",
  "pages.vendor.images": "รูปภาพค่ายเกม",
  "pages.vendor.syncAllGame": "Sync All Game",
  "pages.vendor.syncSuccess": "ซิงค์ค่ายเกม {vendors} รายการแล้ว มีเกมจาก Hub {games} เกม",
  "pages.vendor.syncFailed": "ซิงค์ไม่สำเร็จ",
  "pages.vendor.currency": "สกุลเงินที่ค่ายรองรับ",
  "pages.vendor.updateTitle": "การตั้งค่าค่ายเกม",
  "pages.vendor.id": "ไอดี",
  "pages.vendor.org_id": "ไอดีองค์กร",
  "pages.vendor.sandbox_currency": "สกุลเงินแซนด์บ็อกซ์",
  "pages.vendor.currenciesPlaceholder": "เลือกหรือพิมพ์สกุลเงิน",
  "pages.vendor.categoryPlaceholder": "เลือกหรือพิมพ์ประเภท",
  "pages.vendor.close": "ปิด",
  "pages.vendor.save": "บันทึก",
  "pages.vendor.logo": "โลโก้ค่ายเกม",
  "pages.vendor.banner": "แบนเนอร์ค่ายเกม",
  "pages.vendor.notes": "หมายเหตุ",
  "pages.vendor.banner_image_url": "URL รูปภาพแบนเนอร์",
  "pages.vendor.banner_image_upload": "อัปโหลดรูปภาพแบนเนอร์",
  "pages.gateway.title": "รายการฮับ",
  "pages.gateway.new": "เพิ่มฮับใหม่",
  "pages.gateway.updateTitle": "การตั้งค่าฮับ",
  "pages.gateway.id": "ไอดี",
  "pages.gateway.code": "รหัส",
  "pages.gateway.codeRequired": "จำเป็นต้องระบุรหัสฮับ",
  "pages.gateway.stage": "ระดับ",
  "pages.gateway.stage.sandbox": "แซนด์บ็อกซ์",
  "pages.gateway.stage.production": "โปรดักชัน",
  "pages.gateway.status": "สถานะปัจจุบัน",
  "pages.gateway.status.active": "ใช้งาน",
  "pages.gateway.status.online": "ใช้งาน",
  "pages.gateway.status.inactive": "ไม่ใช้งาน",
  "pages.gateway.currencies": "สกุลเงิน",
  "pages.gateway.updatedAt": "อัปเดตเมื่อ",
  "pages.gateway.operating": "จัดการ",
  "pages.gateway.syncAll": "ซิงค์ทั้งหมด",
  "pages.gateway.sync": "ซิงค์",
  "pages.gateway.syncSuccess": "เริ่มการซิงค์สำเร็จ",
  "pages.gateway.officialUrl": "URL ทางการ",
  "pages.gateway.hubPartnerBrandIcon": "URL ไอคอนแบรนด์",
  "pages.gateway.announcement": "ประกาศการปรับปรุง",
  "analytics.today": "วันนี้",
  "analytics.week": "สัปดาห์",
  "analytics.month": "เดือน",
  "analytics.year": "ปี",
  "analytics.overview": "ภาพรวม",
  "analytics.players": "Engagement ของผู้เล่น",
  "analytics.finance": "ยอดเงินหมุนเวียน",
  "analytics.products": "ประเภทเกม",
  "analytics.bonus": "โบนัสและค่าใช้จ่าย",
  "analytics.markets": "ตลาด",
  "analytics.ggr": "GGR",
  "analytics.ngr": "NGR",
  "analytics.activePlayers": "ผู้เล่นที่ใช้งาน",
  "analytics.houseEdge": "ขอบเขตบ้าน",
  "analytics.revenueTrend": "แนวโน้มรายได้ (GGR vs NGR)",
  "analytics.productMix": "สัดส่วนสินค้า",
  "analytics.playerFunnel": "กระบวนการผู้เล่น",
  "analytics.activePlayersByProduct": "ผู้เล่นที่ใช้งานต่อสินค้า",
  "analytics.deposits": "เงินฝาก",
  "analytics.withdrawals": "การถอนเงิน",
  "analytics.netDeposits": "เงินฝากสุทธิ",
  "analytics.avgDeposit": "เงินฝากเฉลี่ย",
  "analytics.turnoverVsWinnings": "ยอดเดิมพัน vs เงินรางวัล",
  "analytics.depositBreakdown": "รายละเอียดเงินฝาก",
  "analytics.depositBreakdown.total": "รวม",
  "analytics.depositBreakdown.ftdCount": "จำนวน FTD",
  "analytics.depositBreakdown.depositCount": "จำนวนการฝาก",
  "analytics.depositBreakdown.uniqueDepositors": "ผู้ฝากรายย่อย",
  "analytics.productPerformance": "การเปรียบเทียบประสิทธิภาพสินค้า",
  "analytics.totalBonus": "โบนัสทั้งหมด",
  "analytics.bonusWithdrawn": "โบนัสที่ถอน",
  "analytics.cashback": "เงินคืน",
  "analytics.bonusCostRatio": "อัตราส่วนค่าใช้จ่ายโบนัส",
  "analytics.bonusImpact": "ผลกระทบโบนัสต่อรายได้",
  "analytics.marketPerformance": "ประสิทธิภาพตลาด",
  "analytics.registrations": "การลงทะเบียน",
  "analytics.ftds": "FTDs",
  "analytics.ftdConversion": "อัตราการแปลง FTD",
  "analytics.depositPenetration": "อัตราการฝากเงิน",
  "analytics.turnover": "ยอดเดิมพัน",
  "pages.gateway.name": "ชื่อ",
  "pages.gateway.securityStrategy": "Security Algorithm",
  "pages.gateway.systemEnvironment": "สภาพแวดล้อมระบบ",
  "pages.common.option": "ตัวเลือก",
  "pages.common.edit": "แก้ไข",
  "pages.gateway.syncFailed": "การเริ่มซิงค์ล้มเหลว โปรดลองอีกครั้ง",
  "pages.gateway.connectionConfig": "การตั้งค่าการเชื่อมต่อ",
  "pages.gateway.advancedConfig": "การตั้งค่าขั้นสูง",
  "pages.game.uat": "อัพเดทเมื่อ",
  "pages.game.cat": "นำเข้าเมื่อ",
  "component.siteSelector.currentSiteLobby": "ไซต์ลอบบี้",
  "pages.common.currencyNotSupported": "ไม่รองรับสกุลเงินของประเทศผู้เล่น",
  "pages.game.title": " ",
  "pages.game.id": "ไอดี",
  "pages.player.list.seeProfile": "ดูโปรไฟล์",
  "pages.player.message-to-player": "ส่งข้อความหา",
  "pages.player.batch-message-to-all-player": "ส่งข้อความหาทุกคน",
  "pages.game.config": "ตั้งค่า",
  "pages.common.add": "เพิ่ม",
  "pages.common.notfound": "ไม่พบข้อมูล",
  "pages.game.new": "เพิ่มเกมใหม่",
  "pages.game.updateTitle": "การตั้งค่าเกม",
  "pages.game.basicInfo": "ข้อมูลพื้นฐาน",
  "pages.game.game": "เกม",
  "pages.game.code": "รหัส",
  "pages.game.vendorId": "รหัสค่ายเกม",
  "pages.game.category": "ประเภท",
  "pages.game.category.none": "ทั้งหมด",
  "pages.game.category.blockchain": "บล็อคเชน",
  "pages.game.category.electronic": "อิเล็กทรอนิกส์",
  "pages.game.category.slot": "สล็อต",
  "pages.game.category.table": "เกมโต๊ะ",
  "pages.game.category.live": "คาสิโนสด",
  "pages.game.category.lottery": "หวย",
  "pages.game.category.fish": "เกมยิงปลา",
  "pages.game.category.arcade": "อาเขต",
  "pages.game.category.sport": "กีฬา",
  "pages.game.category.esport": "อีสปอร์ต",
  "pages.game.officialStatus": "สถานะทางการ",
  "pages.game.status.active": "ใช้งาน",
  "pages.game.status.inactive": "ไม่ใช้งาน",
  "pages.game.status.maintenance": "ปรับปรุง",
  "pages.game.status.online": "ออนไลน์",
  "pages.game.updatedAt": "อัปเดตเมื่อ",
  "pages.game.operating": "จัดการ",
  "pages.game.play": "เล่น",
  "pages.game.set-rtp": "ตั้งระดับ RTP",
  "pages.game.rtp": "RTP",
  "pages.game.rtpConfig": "ตั้งค่า RTP - {name} ({id})",
  "pages.game.rtpLabel": "อัตราการจ่ายคืนผู้เล่น (RTP) %",
  "pages.game.rtpUpdateSuccess": "อัปเดต RTP สำเร็จ",
  "pages.game.rtpUpdateFailed": "การอัปเดต RTP ล้มเหลว",
  "pages.game.rtpFetchFailed": "การดึงข้อมูล RTP ล้มเหลว",
  "pages.game.update": "อัปเดต",
  "pages.game.launch": "เปิดเกม",
  "pages.game.launchFailed": "การเปิดเกมล้มเหลว",
  "pages.game.launchUrlFailed": "ไม่สามารถรับ URL เปิดเกมได้",
  "pages.game.noGameSelected": "ไม่ได้เลือกเกม",
  "pages.game.gameDataNotFound": "ไม่พบข้อมูลเกม",
  "pages.game.playerTokenNotFound": "ไม่พบโทเค็นผู้เล่น",
  "pages.game.missingData": "ขาดรหัสเกมหรือค่ายเกม",
  "pages.game.codeRequired": "จำเป็นต้องระบุรหัสเกม",
  "pages.game.vendorRequired": "จำเป็นต้องระบุค่ายเกม",
  "pages.game.labels": "ป้ายกำกับท้องถิ่น",
  "pages.game.settings": "การตั้งค่าอย่างเป็นทางการ",
  "pages.game.images": "รูปภาพเกม",
  "pages.game.defaultConfig": "การตั้งค่าเริ่มต้น",
  "pages.vendor.cat": "สร้างเมื่อ",
  "pages.vendor.gatewayId": "Gateway ID",
  "pages.vendor.maintenance": "สถานะการบำรุงรักษา",
  "pages.owner.title": "รายการโอเปอเรเตอร์",
  "pages.owner.new": "เพิ่มโอเปอเรเตอร์ใหม่",
  "pages.owner.owner": "โอเปอเรเตอร์",
  "pages.owner.name": "แอดมิน",
  "pages.owner.nameRequired": "จำเป็นต้องระบุชื่อแอดมิน",
  "pages.owner.updateTitle": "การตั้งค่าโอเปอเรเตอร์",
  "pages.owner.budgetConfig": "การตั้งค่าเป้าหมายงบประมาณ",
  "pages.owner.balance": "ยอดคงเหลือ",
  "pages.owner.creditType": "ประเภทเครดิต",
  "pages.owner.creditType.seamless": "Seamless",
  "pages.owner.creditType.prepaid": "Prepaid",
  "pages.owner.currency": "สกุลเงิน",
  "pages.owner.initialLogin": "ล็อกอินครั้งแรก",
  "pages.owner.environment": "สภาพแวดล้อมระบบ",
  "pages.owner.lastActiveTime": "ใช้งานล่าสุดเมื่อ",
  "pages.owner.orgSection": "ข้อมูลองค์กร",
  "pages.owner.orgName": "ชื่อองค์กร",
  "pages.owner.orgNamePlaceholder": "เช่น ACME Corporation",
  "pages.owner.orgCurrencies": "สกุลเงินที่รองรับ",
  "pages.owner.orgCurrenciesPlaceholder": "เลือกสกุลเงิน",
  "pages.owner.ownerSection": "ข้อมูลเจ้าของ",
  "pages.owner.ownerName": "ชื่อ",
  "pages.owner.ownerNamePlaceholder": "เช่น สมชาย ใจดี",
  "pages.owner.ownerUsername": "ชื่อผู้ใช้ (รหัสสมาชิก)",
  "pages.owner.ownerUsernamePlaceholder": "เช่น somchai",
  "pages.owner.ownerUsernameTooltip": "นี่จะถูกใช้กับโดเมนย่อยขององค์กรด้วย",
  "pages.owner.ownerSubdomain": "URL สำหรับการยืนยันตัวตน/ที่ทำงาน",
  "pages.owner.ownerSubdomainPlaceholder": "เช่น dragon-node",
  "pages.owner.ownerSubdomainTooltip": "นี่จะถูกใช้เป็น authLocation.backoffice.com ขององค์กรด้วย",
  "pages.owner.ownerSubdomainFinalize": "URL สุดท้าย:",
  "pages.owner.ownerPhone": "เบอร์โทรศัพท์ (ไม่บังคับ)",
  "pages.owner.invalidPhone": "เบอร์โทรศัพท์ไม่ถูกต้อง",
  "pages.owner.trialSection": "การตั้งค่าทดลองใช้",
  "pages.owner.trialDays": "ระยะเวลาทดลองใช้ (วัน)",
  "pages.searchTable.nameAccountStatus.sandbox": "แซนด์บ็อกซ์",
  "pages.searchTable.nameAccountStatus.production": "โปรดักชัน",
  "pages.searchTable.nameAccountStatus.ban": "แบน",
  "pages.searchTable.nameAccountStatus.pause": "ระงับชั่วคราว",
  "pages.searchTable.name": "ชื่อ",
  "pages.searchTable.cancel": "ยกเลิก",
  "pages.searchTable.save": "บันทึก",
  "pages.game.maintenance": "กำลังปรับปรุง",
  "pages.xcenter.title": "ศูนย์ควบคุม X",
  "pages.xcenter.description": "จัดสรรทรัพยากรของคุณ",
  "pages.xcenter.mode": "โหมด {mode}",
  "pages.xcenter.sandbox": "แซนด์บ็อกซ์",
  "pages.xcenter.syncHubs": "ซิงค์ฮับทั้งหมด",
  "pages.xcenter.saveConfig": "บันทึกการตั้งค่า",
  "pages.xcenter.balance": "ยอดคงเหลือ",
  "pages.xcenter.creditType": "ประเภทเครดิต",
  "pages.xcenter.activeHubs": "ฮับที่ใช้งานอยู่",
  "pages.xcenter.online": "ออนไลน์",
  "pages.xcenter.ownerName": "ชื่อเจ้าของ",
  "pages.xcenter.id": "ไอดี",
  "pages.xcenter.lastUpdated": "อัปเดตล่าสุดเมื่อ",
  "pages.xcenter.ownerNotFound": "ไม่พบข้อมูลเจ้าของ",
  "pages.xcenter.configSaved": "บันทึกการตั้งค่าแล้ว",
  "pages.xcenter.configSaveFailed": "การบันทึกการตั้งค่าล้มเหลว",
  "pages.xcenter.syncFailed": "การขอซิงค์ฮับล้มเหลว",
  "pages.xcenter.noHubsFound": "ไม่พบฮับที่จะซิงค์",
  "pages.xcenter.syncAccepted": "รับคำขอซิงค์ฮับแล้ว",
  "pages.tools.magicEditor": "เครื่องมือแก้ไขอัจฉริยะ",
  "pages.tools.cleanup": "ลบส่วนเกิน",
  "pages.tools.magicEdit": "แก้ไขอัจฉริยะ",
  "pages.tools.placeDesign": "วางงานออกแบบ",
  "pages.tools.colors": "สีสัน",
  "pages.tools.newImage": "รูปใหม่",
  "pages.tools.startCleanup": "เริ่มการลบเป้าหมาย",
  "pages.tools.detectRemoveLogos": "ตรวจจับและลบโลโก้ ลายน้ำ และแบรนด์โดยอัตโนมัติ",
  "pages.tools.describeMagic": "อธิบายสิ่งที่คุณต้องการเปลี่ยน เพิ่ม หรือแทนที่",
  "pages.tools.magicPlaceholder": "เช่น เปลี่ยน 'สมาชิกใหม่' เป็น 'ยินดีต้อนรับ'...",
  "pages.tools.applyEdit": "เริ่มการแก้ไข",
  "pages.tools.uploadDesign": "อัปโหลดงานออกแบบเพื่อนำไปวางบนรูปภาพ",
  "pages.tools.clickToChange": "คลิกเพื่อเปลี่ยน",
  "pages.tools.selectOverlay": "เลือกรูปภาพที่จะวาง",
  "pages.tools.instructionOptional": "คำแนะนำเพิ่มเติม (ทางเลือก):",
  "pages.tools.placePlaceholder": "เช่น วางไว้ตรงกลางเสื้อ...",
  "pages.tools.mergeDesign": "รวมงานออกแบบ",
  "pages.tools.currentPalette": "จานสีปัจจุบัน",
  "pages.tools.rescan": "สแกนใหม่",
  "pages.tools.scanColors": "สแกนสี",
  "pages.tools.modifyTheme": "ปรับเปลี่ยนธีม",
  "pages.tools.themePlaceholder": "เช่น Cyberpunk, Pastel...",
  "pages.tools.syncColors": "ซิงค์สี",
  "pages.tools.selectToolToBegin": "เลือกเครื่องมือเพื่อเริ่มการแก้ไข",
  "pages.tools.editsMade": "แก้ไขไปแล้ว {count} ครั้ง",
  "pages.tools.originalImage": "รูปภาพต้นฉบับ",
  "pages.tools.undo": "ย้อนกลับ",
  "pages.tools.download": "ดาวน์โหลด",
  "pages.tools.geminiWorking": "Gemini กำลังทำงาน...",
  "pages.tools.noImageLoaded": "ยังไม่ได้โหลดรูปภาพ",
  "pages.common.noData": "ไม่มีข้อมูล",
  "pages.common.key": "คีย์",
  "pages.common.value": "ค่า",
  "pages.vendor.images.dragger.title": "คลิกหรือลากไฟล์มายังบริเวณนี้เพื่ออัปโหลด",
  "pages.vendor.images.dragger.hint": "รองรับการอัปโหลดแบบไฟล์เดียวหรือหลายไฟล์พร้อมกัน",
  "pages.management.site-list.title": "รายการเว็บไซต์",
  "pages.management.site-list.new": "เพิ่มเว็บไซต์ใหม่",
  "pages.management.site-list.sites": "จำนวนเว็บไซต์",
  "pages.management.site-list.avgUniqueVisitors": "ผู้เข้าชมเฉลี่ย",
  "pages.management.site-list.totalTraffic": "ทราฟฟิกทั้งหมด",
  "pages.management.site-list.searchNameLabel": "ชื่อ",
  "pages.management.site-list.searchOwnerLabel": "เจ้าของ",
  "pages.management.site-list.placeholder": "ระบุชื่อเว็บไซต์หรือไอดีองค์กร",
  "pages.management.site-list.listTitle": "รายการเว็บไซต์",
  "pages.management.site-list.id": "ไอดี",
  "pages.management.site-list.revenueSummary": "ผลประกอบการล็อบบี้",
  "pages.management.site-list.name": "ชื่อ",
  "pages.management.site-list.currencies": "รองรับสกุลเงิน",
  "pages.management.site-list.status": "สภาพแวดล้อมระบบ",
  "pages.management.site-list.status.live": "Live",
  "pages.management.site-list.status.sandbox": "Sandbox",
  "pages.management.site-list.orgId": "ไอดีองค์กร",
  "pages.management.site-list.cat": "สร้างเมื่อ",
  "pages.management.site-list.edit": "แก้ไข",
  "pages.management.site-list.share": "แชร์",
  "pages.management.site-list.delete": "ลบ",
  "pages.management.site-list.more": "เพิ่มเติม",
  "pages.management.site-list.deleteConfirmTitle": "ยืนยันการลบเว็บไซต์นี้?",
  "pages.management.site-list.deleteConfirmContent": "การดำเนินการนี้ไม่สามารถย้อนกลับได้",
  "pages.management.site-list.form.siteName": "ชื่อเว็บไซต์",
  "pages.management.site-list.form.currencies": "สกุลเงิน",
  "pages.management.site-list.form.orgId": "ไอดีองค์กร",
  "pages.management.site-list.form.config": "การตั้งค่าเว็บไซต์ (JSON)",
  "pages.management.site-list.form.siteNameRequired": "กรุณาระบุชื่อเว็บไซต์",
  "pages.management.site-list.form.currenciesRequired": "กรุณาเลือกอย่างน้อยหนึ่งสกุลเงิน",
  "pages.management.site-list.form.orgIdRequired": "กรุณาระบุไอดีองค์กร",
  "pages.management.site-list.form.success": "ดำเนินการสำเร็จ",
  "pages.management.site-list.form.backToList": "กลับไปที่รายการ",
  "pages.management.site-list.form.addAgain": "เพิ่มอีกครั้ง",
  "pages.management.site-manager.title": "จัดการไซต์",
  "pages.management.site-manager.description": "จัดการไซต์และขยายล็อบบี้ได้ง่ายๆ ในคลิกเดียว",
  "pages.management.site-manager.balance": "ยอดคงเหลือ",
  "pages.management.site-manager.provision": "การจัดสรร",
  "pages.management.site-manager.newSite": "ไซต์ใหม่",
  "pages.management.site-manager.refresh": "รีเฟรช",
  "pages.management.site-manager.openMoreLobby": "เปิดล็อบบี้เพิ่ม",
  "pages.management.site-manager.openWhiteLabel": "เปิดบ้านใหม่",
  "pages.management.site-manager.lobbiesCount": "ล็อบบี้ ({count})",
  "pages.management.site-manager.detail": "รายละเอียด",
  "pages.management.site-manager.action": "การดำเนินการ",
  "pages.management.site-manager.currentSite": "ไซต์ปัจจุบัน",
  "pages.management.site-manager.switchToSite": "สลับไปใช้ไซต์นี้",
  "pages.management.site-manager.customizeTheme": "ปรับแต่งธีม",
  "pages.management.site-manager.playerAnalytic": "วิเคราะห์ผู้เล่น",
  "pages.management.site-manager.configDb": "ตั้งค่า DB",
  "pages.management.site-manager.comingSoon": "เร็วๆ นี้",
  "pages.management.site-manager.scalingTitle": "เปิดล็อบบี้ใหม่",
  "pages.management.site-manager.scalingDesc": "สร้างไซต์ใหม่ (ล็อบบี้) สำหรับการขยายระบบ",
  "pages.management.site-manager.parentSite": "ไซต์หลัก",
  "pages.management.site-manager.newSiteName": "ชื่อไซต์ใหม่",
  "pages.management.site-manager.priceBreakdown": "รายละเอียดราคา",
  "pages.management.site-manager.creationFee": "ค่าธรรมเนียมการสร้างไซต์",
  "pages.management.site-manager.setupFee": "ค่าธรรมเนียมการตั้งค่า",
  "pages.management.site-manager.total": "รวม",
  "pages.management.site-manager.yourBalance": "ยอดเงินของคุณ",
  "pages.management.site-manager.afterPurchase": "ยอดเงินคงเหลือหลังหักค่าใช้จ่าย",
  "pages.management.site-manager.insufficientBalance": "ยอดเงินไม่เพียงพอ กรุณาเติมเงินในบัญชีของคุณ",
  "pages.management.site-manager.confirmProvision": "ฉันยืนยันให้หักเงิน {amount} จากบัญชีของฉัน",
  "pages.management.site-manager.confirmCreate": "ยืนยันและสร้าง",
  "pages.management.site-manager.close": "ปิด",
  "pages.management.site-manager.openNewHouse": "เปิดบ้านใหม่",
  "pages.management.site-manager.selectSite": "เลือกไซต์",
  "pages.management.site-manager.switchSuccess": "สลับไปยังไซต์ {name} สำเร็จ",
  "pages.management.transactions.txId": "รหัสธุรกรรม",
  "pages.management.transactions.playerId": "รหัสผู้เล่น",
  "pages.management.transactions.gameId": "รหัสเกม",
  "pages.management.transactions.at": "เวลา",
  "pages.management.transactions.ref_code": "รหัสอ้างอิง (REF)",
  "pages.vendor.ggr.title": "ผู้จัดการ GGR ของค่ายเกม",
  "pages.vendor.ggr.subtitle": "การตั้งค่าการแบ่งรายได้และการเรียกเก็บเงิน",
  "pages.vendor.ggr.org": "Organization:",
  "pages.vendor.ggr.tab.draft": "รายการผู้ให้บริการและข้อมูล",
  "pages.vendor.ggr.tab.configure": "ตั้งค่า GGR",
  "pages.vendor.ggr.tab.simulate": "จำลองรายได้",
  "pages.vendor.ggr.draft.title": "เลือกค่ายเกม",
  "pages.vendor.ggr.draft.subtitle": "เลือกค่ายเกมที่ต้องการเพิ่มในองค์กรของคุณ",
  "pages.vendor.ggr.draft.search": "ค้นหาค่ายเกม...",
  "pages.vendor.ggr.draft.all": "ทั้งหมด",
  "pages.vendor.ggr.draft.available": "มีค่ายเกม {count} รายการ",
  "pages.vendor.ggr.draft.selected": "เลือกแล้ว {count} รายการ",
  "pages.vendor.ggr.draft.noMatch": "ไม่พบค่ายเกมที่ตรงกับเกณฑ์",
  "pages.vendor.ggr.card.ggrRate": "อัตรา GGR:",
  "pages.vendor.ggr.card.platform": "แพลตฟอร์ม:",
  "pages.vendor.ggr.card.billing": "วันเรียกเก็บ:",
  "pages.vendor.ggr.card.fees": "ค่าธรรมเนียม:",
  "pages.vendor.ggr.config.title": "การตั้งค่าระดับ GGR",
  "pages.vendor.ggr.config.subtitle": "ตั้งค่าอัตราการแบ่งรายได้และตารางการเรียกเก็บเงิน",
  "pages.vendor.ggr.config.selectTier": "เลือกระดับที่ต้องการแก้ไข",
  "pages.vendor.ggr.config.selectTierEmpty": "เลือกระดับ",
  "pages.vendor.ggr.config.selectTierEmptyDesc": "เลือกระดับจากด้านซ้ายเพื่อตั้งค่า",
  "pages.vendor.ggr.config.minGGR": "GGR ขั้นต่ำ (USDT)",
  "pages.vendor.ggr.config.maxGGR": "GGR สูงสุด (USDT)",
  "pages.vendor.ggr.config.unlimited": "ไม่จำกัด",
  "pages.vendor.ggr.config.vendorRate": "อัตราค่ายเกม",
  "pages.vendor.ggr.config.platformRate": "อัตราแพลตฟอร์ม",
  "pages.vendor.ggr.config.maintenanceFee": "ค่าบำรุงรักษา",
  "pages.vendor.ggr.config.serviceFee": "ค่าบริการ",
  "pages.vendor.ggr.config.billingSchedule": "ตารางการเรียกเก็บเงิน",
  "pages.vendor.ggr.config.billDay": "วันเรียกเก็บ",
  "pages.vendor.ggr.config.fineDays": "วันปรับ",
  "pages.vendor.ggr.config.suspend": "ระงับ",
  "pages.vendor.ggr.config.terminate": "ยกเลิก",
  "pages.org.hierarchy.member": "สมาชิก",
  "pages.org.hierarchy.operator": "เมมเบอร์",
  "pages.org.hierarchy.operators": "เมมเบอร์",
  "pages.site.hierarchy.environment": "สภาพแวดล้อม",
  "pages.site.hierarchy.player": "ผู้เล่น",
  "pages.site.hierarchy.players": "ผู้เล่น",
  "pages.vendor.ggr.simulate.title": "การจำลองรายได้",
  "pages.vendor.ggr.simulate.subtitle": "ประเมินการเงินและดูตารางการเรียกเก็บเงิน",
  "pages.vendor.ggr.simulate.noVendors": "ยังไม่ได้เลือกค่ายเกม",
  "pages.vendor.ggr.simulate.noVendorsDesc": "เลือกค่ายเกมจากรายการเพื่อจำลองการแบ่งรายได้",
  "pages.vendor.ggr.simulate.totalGGR": "GGR รวม",
  "pages.vendor.ggr.simulate.totalGGRTooltip": "รายได้รวมจากเกมทั้งหมดของค่ายเกมที่เลือก",
  "pages.vendor.ggr.simulate.vendorShare": "ส่วนแบ่งค่ายเกม",
  "pages.vendor.ggr.simulate.vendorShareTooltip": "ประมาณการส่วนแบ่งที่ต้องจ่ายให้ค่ายเกม",
  "pages.vendor.ggr.simulate.platformShare": "ส่วนแบ่งแพลตฟอร์ม",
  "pages.vendor.ggr.simulate.platformShareTooltip": "ประมาณการส่วนแบ่งที่แพลตฟอร์มได้รับ",
  "pages.vendor.ggr.simulate.totalDue": "ยอดรวมที่ต้องชำระ",
  "pages.vendor.ggr.simulate.totalDueTooltip": "ยอดรวมทั้งหมดรวมค่าบำรุงรักษาและค่าบริการ",
  "pages.vendor.ggr.simulate.distribution": "การกระจายรายได้",
  "pages.vendor.ggr.simulate.perVendor": "การจำลองแยกตามค่ายเกม",
  "pages.vendor.ggr.simulate.estimatedGGR": "GGR ประมาณการ",
  "pages.vendor.ggr.simulate.vendor": "ค่ายเกม:",
  "pages.vendor.ggr.simulate.platform": "แพลตฟอร์ม:",
  "pages.vendor.ggr.simulate.fees": "ค่าธรรมเนียม:",
  "pages.vendor.ggr.simulate.total": "รวม:",
  "pages.vendor.ggr.simulate.schedule": "ตารางการเงินและกำหนดเวลา",
  "pages.vendor.ggr.simulate.table.vendor": "ค่ายเกม",
  "pages.vendor.ggr.simulate.table.amount": "จำนวนเงิน",
  "pages.vendor.ggr.simulate.table.due": "ครบกำหนด",
  "pages.vendor.ggr.simulate.table.fine": "ปรับ",
  "pages.vendor.ggr.simulate.table.suspend": "ระงับ",
  "pages.vendor.ggr.simulate.table.terminate": "ยกเลิก",
  "pages.vendor.ggr.simulate.table.total": "รวม",
  "pages.vendor.ggr.selectVendor": "เลือกค่ายเกม",
  "pages.vendor.ggr.selectVendorPlaceholder": "เลือกค่ายเกม...",
  "pages.vendor.ggr.tab.tiers": "ระดับ GGR",
  "pages.vendor.ggr.tab.contract": "สัญญาของผู้ให้บริการ",
  "pages.vendor.ggr.config.addFirstTier": "เพิ่มระดับแรก",
  "pages.vendor.ggr.config.addTier": "เพิ่มระดับ",
  "pages.vendor.ggr.config.noTiers": "ยังไม่มีระดับ GGR ที่ตั้งค่า",
  "pages.vendor.image.title": "รูปภาพค่ายเกม",
  "pages.vendor.image.subtitle": "จัดการรูปภาพและหมวดหมู่ของค่ายเกม",
  "pages.vendor.image.upload": "อัปโหลดรูปภาพ",
  "pages.vendor.image.uploadSuccess": "อัปโหลดรูปภาพสำเร็จ",
  "pages.vendor.image.uploadError": "อัปโหลดรูปภาพล้มเหลว",
  "pages.vendor.image.deleteSuccess": "ลบรูปภาพสำเร็จ",
  "pages.vendor.image.deleteError": "ลบรูปภาพล้มเหลว",
  "pages.vendor.image.vendorName": "ชื่อค่ายเกม",
  "pages.vendor.image.categories": "หมวดหมู่",
  "pages.vendor.image.currentImages": "รูปภาพปัจจุบัน",
  "pages.vendor.image.invalidFile": "ประเภทไฟล์ไม่ถูกต้อง",
  "pages.vendor.image.fileTooLarge": "ไฟล์ใหญ่เกินไป (สูงสุด 2MB)",
  "pages.support.robot.welcome": "สวัสดีครับ! ผมคือผู้ช่วย AI ของคุณ มีอะไรให้ผมช่วยคุณในวันนี้ไหมครับ?",
  "pages.support.robot.placeholder": "สอบถามข้อมูลเพิ่มเติมได้ที่นี่...",
  "pages.403.subTitle": "ขออภัย คุณไม่มีสิทธิ์เข้าถึงหน้านี้",
  "pages.403.buttonText": "กลับหน้าหลัก",
  "component.footer.copyright": "2026 EIGHT DRAGON GLOBAL. All rights reserved. ·",
  "component.footer.contact": "ติดต่อเราที่เว็บไซต์ทางการ",
  "component.avatarDropdown.account": "บัญชี",
  "component.avatarDropdown.logout": "ออกจากระบบ",
  "component.siteSelector.title": "เลือกไซต์และผู้เล่น",
  "component.siteSelector.description": "เลือกไซต์เพื่อดำเนินการต่อ",
  "component.siteSelector.selectLobby": "กรุณาเลือกล็อบบี้ไซต์ที่ต้องการทดสอบเกม",
  "component.siteSelector.placeholder": "เลือกล็อบบี้ไซต์",
  "component.siteSelector.confirm": "เปิดเกม",
  "component.siteSelector.cancel": "ยกเลิก",
  "component.siteSelector.playerPlaceholder": "เลือกผู้เล่น...",
  "component.siteSelector.loadingSites": "กำลังโหลดผู้เล่น...",
  "pages.vendor.ggr.card.day": "วัน",
  "pages.vendor.ggr.card.fees.maintenance": "ค่าธรรมเนียมการดูแลรักษา",
  "pages.vendor.ggr.card.fees.service": "ค่าธรรมเนียมการบริการ",
  "component.gameLaunch.scanOrPress": "สแกน QR Code หรือกดปุ่มเพื่อเล่นเกม",
  "component.gameLaunch.openNewWindow": "เปิดเกมในหน้าต่างใหม่",
  "component.gameLaunch.copyUrl": "คัดลอก URL",
  "component.gameLaunch.copySuccess": "คัดลอก URL สำเร็จ",
  "component.gameLaunch.copyFailed": "ไม่สามารถคัดลอก URL ได้",
  "component.gameLaunch.sessionID": "Session ID:",
  "component.gameLaunch.goToMonitor": "ไปหน้า Monitor ผู้เล่น",
  "component.loading.tip": "...",
  "component.magicEditor.editsMade": "แก้ไขไปแล้ว {count} ครั้ง",
  "component.magicEditor.originalImage": "รูปภาพต้นฉบับ",
  "component.magicEditor.undo": "ย้อนกลับ",
  "component.magicEditor.download": "ดาวน์โหลด",
  "component.magicEditor.geminiWorking": "Gemini กำลังทำงาน...",
  "component.magicEditor.noImageLoaded": "ยังไม่ได้โหลดรูปภาพ",
  "component.magicEditor.detectRemoveLogos": "ตรวจจับและลบโลโก้ ลายน้ำ และแบรนด์โดยอัตโนมัติ",
  "component.magicEditor.startCleanup": "เริ่มการลบเป้าหมาย",
  "component.magicEditor.describeMagic": "อธิบายสิ่งที่คุณต้องการเปลี่ยน เพิ่ม หรือแทนที่",
  "component.magicEditor.magicPlaceholder": "เช่น เปลี่ยน 'สมาชิกใหม่' เป็น 'ยินดีต้อนรับ'...",
  "component.magicEditor.applyEdit": "เริ่มการแก้ไข",
  "component.magicEditor.uploadDesign": "อัปโหลดงานออกแบบเพื่อนำไปวางบนรูปภาพ",
  "component.magicEditor.clickToChange": "คลิกเพื่อเปลี่ยน",
  "component.magicEditor.selectOverlay": "เลือกรูปภาพที่จะวาง",
  "component.magicEditor.instructionOptional": "คำแนะนำเพิ่มเติม (ทางเลือก):",
  "component.magicEditor.placePlaceholder": "เช่น วางไว้ตรงกลางเสื้อ...",
  "component.magicEditor.mergeDesign": "รวมงานออกแบบ",
  "component.magicEditor.currentPalette": "จานสีปัจจุบัน",
  "component.magicEditor.rescan": "สแกนใหม่",
  "component.magicEditor.scanColors": "สแกนสี",
  "component.magicEditor.modifyTheme": "ปรับเปลี่ยนธีม",
  "component.magicEditor.themePlaceholder": "เช่น Cyberpunk, Pastel...",
  "component.magicEditor.syncColors": "ซิงค์สี",
  "component.magicEditor.selectToolToBegin": "เลือกเครื่องมือเพื่อเริ่มการแก้ไข",
  "component.magicEditor.agenticAI": "Agentic AI",
  "component.magicEditor.uploadNewImage": "อัปโหลดรูปภาพใหม่",
  "component.magicEditor.newImage": "รูปใหม่",
  "component.magicEditor.cleanup": "ลบส่วนเกิน",
  "component.magicEditor.magicEdit": "แก้ไขอัจฉริยะ",
  "component.magicEditor.placeDesign": "วางงานออกแบบ",
  "component.magicEditor.colors": "สีสัน",
  "component.magicEditor.imageUploaded": "อัปโหลดรูปภาพสำเร็จ",
  "component.magicEditor.logosRemoved": "ลบโลโก้แล้ว",
  "component.magicEditor.logoRemoveFailed": "การลบโลโก้ล้มเหลว กรุณาลองอีกครั้ง",
  "component.magicEditor.editApplied": "นำการแก้ไขไปใช้แล้ว",
  "component.magicEditor.editFailed": "การประมวลผลการแก้ไขล้มเหลว กรุณาลองอีกครั้ง",
  "component.magicEditor.colorsSynced": "ซิงค์สีแล้ว",
  "component.magicEditor.recolorFailed": "การเปลี่ยนสีรูปภาพล้มเหลว กรุณาลองอีกครั้ง",
  "component.magicEditor.designPlaced": "วางงานออกแบบสำเร็จ",
  "component.magicEditor.placeFailed": "การวางงานออกแบบล้มเหลว กรุณาลองอีกครั้ง",
  "component.magicEditor.extractingPalette": "กำลังดึงจานสี...",
  "component.magicEditor.paletteExtracted": "ดึงจานสีแล้ว",
  "component.magicEditor.paletteFailed": "การดึงจานสีล้มเหลว กรุณาลองอีกครั้ง",
  "pages.management.players.title": "การจัดการผู้เล่น",
  "pages.management.players.player": "ผู้เล่น",
  "pages.management.players.anonymous": "ไม่ระบุตัวตน",
  "pages.management.players.id": "ID",
  "pages.management.players.siteId": "Site ID",
  "pages.management.players.currency": "สกุลเงิน",
  "pages.management.players.balance": "ยอดคงเหลือ",
  "pages.management.players.status": "สถานะ",
  "pages.management.players.status.active": "ออนไลน์",
  "pages.management.players.status.inactive": "ออฟไลน์",
  "pages.management.players.status.banned": "ถูกแบน",
  "pages.management.players.cat": "สร้างเมื่อ",
  "pages.management.players.total": "ทั้งหมด {total} ผู้เล่น",
  "pages.management.players.transactionHistory": "ประวัติธุรกรรม",
  "management.playerDetail.title": "รายละเอียดผู้เล่น",
  "withdraw.history.createdAt": "วันที่สร้าง",
  "withdraw.history.bonusName": "ชื่อโบนัส",
  "withdraw.history.slip": "สลิป",
  "pages.login.pleaseVerifyCaptcha": "Please verify that you are not a robot.",
  "pages.management.transactions.profit": "ผลกำไร",
  "pages.management.transactions.siteId": "ไอดีไซต์",
  "pages.management.transactions.amount": "จำนวนเงิน",
  "pages.management.transactions.createdAt": "วันที่/เวลา",
  "pages.management.transactions.type": "ประเภท",
  "pages.management.transactions.type.deposit": "ฝากเงิน",
  "pages.management.transactions.type.withdraw": "ถอนเงิน",
  "pages.management.transactions.type.transfer": "โอนเงิน",
  "pages.management.transactions.type.bet": "เดิมพัน",
  "pages.management.transactions.type.win": "ชนะ",
  "pages.management.transactions.status": "สถานะ",
  "pages.management.transactions.status.success": "สำเร็จ",
  "pages.management.transactions.status.pending": "รอดำเนินการ",
  "pages.management.transactions.status.failed": "ล้มเหลว",
  "pages.management.transactions.cat": "สร้างเมื่อ",
  "pages.management.site-builder.comingSoon": "เร็ว ๆ นี้!",
  "pages.management.site-builder.onDevelopment": "กำลังพัฒนาตัวสร้างเว็บไซต์ให้คุณ!",
  "pages.xudo.game.cat": "หมวยหมวด",
  "pages.xudo.game.select": "เลือก",
  "pages.xudo.game.form.maintenanceTooltip": "กำหนดวันที่เพื่อกำหนดการบำรุงรักษา เคลียร์เพื่อตั้งเป็นปกติ",
  "pages.xudo.game.form.envTooltip": "คู่ key-value สำหรับสภาพแวดล้อมฮับ (เช่น XGLOBAL_SITE, XGLOBAL_PUBLIC_KEY)",
  "pages.xudo.xhub.form.maintenanceTooltip": "กำหนดวันที่เพื่อกำหนดการบำรุงรักษา เคลียร์เพื่อตั้งเป็นปกติ",
  "pages.xudo.xhub.form.envTooltip": "คู่ key-value สำหรับสภาพแวดล้อมฮับ (เช่น XGLOBAL_SITE, XGLOBAL_PUBLIC_KEY)",
  "pages.xudo.game.title": "จัดการเกม X",
  "pages.xudo.game.tab.all": "ทั้งหมด",
  "pages.xudo.game.msg.launched": "เปิดเกมสำเร็จ!",
  "pages.xudo.game.msg.launchFailed": "เปิดเกมล้มเหลว",
  "pages.xudo.game.msg.deleted": "ลบแล้ว",
  "pages.xudo.game.msg.updated": "อัพเดตสำเร็จ",
  "pages.xudo.game.msg.maintenance": "เกมอยู่ในช่วงปรับปรุง",
  "pages.xudo.game.btn.deactivate": "ปิดการใช้งาน",
  "pages.xudo.game.btn.update": "อัพเดต",
  "pages.xudo.game.btn.delete": "ลบ",
  "pages.xudo.game.selectedCount": "เลือกแล้ว {count} รายการ",
  "pages.games.title": "จัดการเกม",
  "pages.games.vendor": "ผู้ให้บริการ",
  "pages.games.maintenance": "สถานะ",
  "pages.org.analysis.excelView": "มุมมอง Excel (เร็ว ๆ นี้)",
  "pages.org.analysis.csvView": "มุมมอง CSV (เร็ว ๆ นี้)",
  "pages.org.monitor.liveGrossRevenue": "การเติบโตของรายได้รวมแบบเรียลไทม์",
  "pages.org.monitor.watch": "ดู",
  "pages.account.settings.base.areaCodeRequired": "กรุณากรอกรหัสพื้นที่!",
  "pages.account.settings.base.phoneRequired": "กรุณากรอกหมายเลขโทรศัพท์!",
  "pages.account.settings.base.updateSuccess": "อัปเดตข้อมูลพื้นฐานสำเร็จ",
  "pages.account.settings.base.submitText": "อัปเดตข้อมูล",
  "pages.account.settings.base.displayName": "ชื่อที่แสดง",
  "pages.account.settings.base.displayNameRequired": "กรุณากรอกชื่อของคุณ!",
  "pages.account.settings.base.username": "ชื่อผู้ใช้",
  "pages.account.settings.base.usernameRequired": "กรุณากรอกชื่อผู้ใช้ของคุณ!",
  "pages.account.settings.base.phoneNumber": "หมายเลขโทรศัพท์",
  "pages.account.settings.base.accountInfo": "ข้อมูลบัญชี",
  "pages.account.settings.base.userUid": "User UID",
  "pages.account.settings.base.orgId": "Organization ID",
  "pages.account.settings.base.systemRole": "บทบาทในระบบ",
  "pages.account.settings.base.orgRole": "บทบาทในองค์กร",
  "pages.account.settings.base.accountStatus": "สถานะบัญชี",
  "pages.account.settings.base.creditType": "ประเภทเครดิต",
  "pages.account.settings.base.usdtBalance": "ยอดเครดิต USDT",
  "pages.account.settings.base.integrationSettings": "การตั้งค่าการเชื่อมต่อ",
  "pages.account.settings.base.superiaProjectUrl": "Superia Project URL",
  "pages.account.settings.base.superiaPublishableKey": "Superia Publishable Key",
  "pages.account.settings.base.avatar": "รูปโปรไฟล์",
  "pages.account.settings.base.changeAvatar": "เปลี่ยนรูปโปรไฟล์",
  "pages.account.settings.security.strong": "แข็งแกร่ง",
  "pages.account.settings.security.medium": "ปานกลาง",
  "pages.account.settings.security.weak": "อ่อนแอ",
  "pages.account.settings.security.accountPassword": "รหัสผ่านบัญชี",
  "pages.account.settings.security.currentStrength": "ความแข็งแกร่งรหัสผ่านปัจจุบัน:",
  "pages.account.settings.security.modify": "แก้ไข",
  "pages.account.settings.security.backupPhone": "โทรศัพท์สำรอง",
  "pages.account.settings.security.boundPhone": "โทรศัพท์ที่ผูกไว้:",
  "pages.account.settings.security.backupQuestion": "คำถามสำรอง",
  "pages.account.settings.security.noBackupQuestion": "ยังไม่ได้ตั้งคำถามสำรอง คำถามสำรองช่วยปกป้องบัญชีของคุณได้อย่างมีประสิทธิภาพ",
  "pages.account.settings.security.set": "ตั้งค่า",
  "pages.account.settings.security.backupEmail": "อีเมลสำรอง",
  "pages.account.settings.security.boundEmail": "อีเมลที่ผูกไว้:",
  "pages.account.settings.security.mfaDevice": "อุปกรณ์ MFA",
  "pages.account.settings.security.noMfaDevice": "ยังไม่ได้ผูกอุปกรณ์ MFA การผูกหลังจากนี้สามารถทำการยืนยันซ้ำได้",
  "pages.account.settings.security.bind": "ผูก",
  "pages.account.settings.binding.taobao": "ผูก Taobao",
  "pages.account.settings.binding.taobaoNotBound": "ยังไม่ได้ผูกบัญชี Taobao",
  "pages.account.settings.binding.alxpay": "ผูก Alxpay",
  "pages.account.settings.binding.alxpayNotBound": "ยังไม่ได้ผูกบัญชี Alxpay",
  "pages.account.settings.binding.dingtalk": "ผูก DingTalk",
  "pages.account.settings.binding.dingtalkNotBound": "ยังไม่ได้ผูกบัญชี DingTalk",
  "pages.account.settings.binding.bind": "ผูก",
  "pages.account.center.assetBalance": "ยอดเงินคงเหลือ",
  "pages.account.center.creditLimit": "วงเงินเครดิต",
  "pages.account.center.wallet": "กระเป๋า",
  "pages.account.center.increase": "เพิ่ม",
  "pages.account.center.card": "บัตร",
  "pages.account.center.confirmed": "ยืนยันแล้ว",
  "pages.account.center.success": "สำเร็จ",
  "pages.account.center.binance": "BINANCE",
  "pages.account.center.instant": "ทันที",
  "pages.account.center.publishedAt": "เผยแพร่เมื่อ",
  "pages.welcome.title": "ยินดีต้อนรับสู่ iGM Backoffice",
  "pages.welcome.description": "iGM Backoffice เป็นแพลตฟอร์มครบวงจรที่รวม umi, Ant Design และ ProComponents ออกแบบมาเพื่อมอบประสบการณ์ที่ราบรื่นสำหรับการจัดการการดำเนินงานเกม การจัดการผู้เล่น และการกำหนดค่าเว็บไซต์",
  "pages.welcome.learnMore": "เรียนรู้เพิ่มเติม",
  "pages.welcome.card1.title": "เรียนรู้ umi",
  "pages.welcome.card1.desc": "umi เป็นเฟรมเวิร์กแอปพลิเคชันส่วนหน้าระดับองค์กรที่ขยายได้ ใช้การกำหนดเส้นทางเป็นพื้นฐานและรองรับทั้งการกำหนดเส้นทางแบบกำหนดค่าและแบบตามข้อตกลง",
  "pages.welcome.card2.title": "เรียนรู้ Ant Design",
  "pages.welcome.card2.desc": "antd เป็นไลบรารีคอมโพเนนต์ React UI ที่ใช้ Ant Design เป็นหลักสำหรับการพัฒนาผลิตภัณฑ์แบ็กเอนด์ระดับองค์กร",
  "pages.welcome.card3.title": "เรียนรู้ Pro Components",
  "pages.welcome.card3.desc": "ProComponents เป็นไลบรารีคอมโพเนนต์เทมเพลตที่ใช้ Ant Design พร้อมการแยกส่วนที่สูงขึ้น ออกแบบด้วยแนวคิดหนึ่งคอมโพเนนต์ต่อหนึ่งหน้า",
  "pages.result.fail.title": "การส่งล้มเหลว",
  "pages.result.fail.subTitle": "กรุณาตรวจสอบและแก้ไขข้อมูลต่อไปนี้ แล้วส่งใหม่อีกครั้ง",
  "pages.result.fail.errorTitle": "การส่งของคุณมีข้อผิดพลาดดังต่อไปนี้:",
  "pages.result.fail.accountFrozen": "บัญชีของคุณถูกระงับ",
  "pages.result.fail.unfreezeNow": "ปลดล็อคทันที",
  "pages.result.fail.notEligible": "บัญชีของคุณยังไม่มีคุณสมบัติในการสมัคร",
  "pages.result.fail.upgradeNow": "อัปเกรดทันที",
  "pages.result.fail.returnToModify": "กลับไปแก้ไข",
  "pages.result.success.title": "ส่งสำเร็จ",
  "pages.result.success.subTitle": "หน้าผลลัพธ์การส่งใช้สำหรับแสดงผลการประมวลผลของชุดงานการดำเนินงาน หากเป็นเพียงการดำเนินงานง่ายๆ ให้ใช้การแจ้งเตือนข้อความทั่วไป พื้นที่ข้อความนี้สามารถแสดงคำอธิบายเพิ่มเติมอย่างง่าย",
  "pages.result.success.backToList": "กลับไปยังรายการ",
  "pages.result.success.viewProject": "ดูโปรเจกต์",
  "pages.result.success.print": "พิมพ์",
  "pages.result.success.projectName": "ชื่อโปรเจกต์",
  "pages.result.success.projectId": "รหัสโปรเจกต์",
  "pages.result.success.principal": "ผู้รับผิดชอบ",
  "pages.result.success.effectiveTime": "เวลาที่มีผลบังคับใช้",
  "pages.result.success.createProject": "สร้างโปรเจกต์",
  "pages.result.success.departmentReview": "การตรวจสอบแผนก",
  "pages.result.success.financialReview": "การตรวจสอบการเงิน",
  "pages.result.success.finish": "เสร็จสิ้น",
  "pages.result.success.urge": "เร่งรัด",
  "pages.fund.title": "บิล",
  "pages.fund.tab.asset": "กระเป๋า",
  "pages.fund.subtitle": "จัดการโควต้าไซต์และการเรียกเก็บเงินของคุณ",
  "pages.fund.packages.title": "แพ็คเกจที่มีจำหน่าย",
  "pages.fund.packages.sites": "แพ็คเกจไซต์",
  "pages.fund.packages.storage": "แพ็คเกจพื้นที่จัดเก็บ",
  "pages.fund.packages.bandwidth": "แพ็คเกจแบนด์วิดท์",
  "pages.fund.currentUsage": "การใช้งานปัจจุบัน",
  "pages.fund.totalSites": "ไซต์ทั้งหมด",
  "pages.fund.sitesUsed": "ไซต์ที่ใช้",
  "pages.fund.sitesRemaining": "ไซต์ที่เหลือ",
  "pages.fund.buyQuota": "ซื้อโควต้า",
  "pages.fund.purchase": "ซื้อ",
  "pages.fund.paymentMethod": "การเงิน",
  "pages.fund.crypto": "สกุลเงินดิจิทัล",
  "pages.fund.price": "ราคา",
  "pages.fund.quantity": "จำนวน",
  "pages.fund.total": "รวม",
  "pages.fund.status": "สถานะ",
  "pages.fund.active": "ใช้งาน",
  "pages.fund.pending": "รอดำเนินการ",
  "pages.fund.completed": "เสร็จสมบูรณ์",
  "pages.fund.discount": "ส่วนลด",
  "pages.fund.popular": "ยอดนิยม",
  "pages.fund.perSite": "ต่อไซต์",
  "pages.fund.savings": "ประหยัด",
  "pages.billing.title": "การเรียกเก็บเงิน",
  "pages.billing.balance": "ยอดคงเหลือ",
  "pages.billing.availableBalance": "ยอดคงเหลือที่ใช้ได้",
  "pages.billing.topup": "เติมเงิน",
  "pages.billing.topupCrypto": "เติมเงินด้วยคริปโต",
  "pages.billing.topupAmount": "จำนวนเงินเติม",
  "pages.billing.selectCurrency": "เลือกสกุลเงิน",
  "pages.billing.paymentAddress": "ที่อยู่ชำระเงิน",
  "pages.billing.copyAddress": "คัดลอกที่อยู่",
  "pages.billing.copied": "คัดลอกแล้ว!",
  "pages.billing.waitingPayment": "รอการเงิน...",
  "pages.billing.paymentConfirmed": "ยืนยันการเงินแล้ว!",
  "pages.billing.paymentExpired": "การเงินหมดอายุ",
  "pages.billing.transactionHistory": "ประวัติธุรกรรม",
  "pages.billing.noTransactions": "ไม่พบธุรกรรม",
  "pages.billing.date": "วันที่",
  "pages.billing.type": "ประเภท",
  "pages.billing.deposit": "ฝากเงิน",
  "pages.billing.purchase": "ซื้อ",
  "pages.billing.refund": "คืนเงิน",
  "pages.payment.step.creating": "กำลังสร้าง",
  "pages.payment.step.payment": "ชำระเงิน",
  "pages.payment.step.complete": "เสร็จสมบูรณ์",
  "pages.payment.creatingRequest": "กำลังสร้างคำขอชำระเงินของคุณ...",
  "pages.payment.creatingUsdtRequest": "กำลังสร้างคำขอชำระเงิน USDT ของคุณ...",
  "pages.payment.details": "รายละเอียดการเงิน",
  "pages.payment.usdtDetails": "รายละเอียดการเงิน USDT",
  "pages.payment.waiting": "กำลังรอการเงิน...",
  "pages.payment.amount": "จำนวน",
  "pages.payment.amountToPay": "จำนวนที่ต้องชำระ",
  "pages.payment.usdValue": "มูลค่า USD",
  "pages.payment.fund": "โควต้า",
  "pages.payment.siteName": "ชื่อไซต์",
  "pages.payment.network": "เครือข่าย",
  "pages.payment.scanToPay": "สแกนเพื่อชำระ",
  "pages.payment.sendExactly": "ส่ง {amount} {currency} ให้ถูกต้อง",
  "pages.payment.copy": "คัดลอก",
  "pages.payment.address": "ที่อยู่",
  "pages.payment.received": "ได้รับ{currency}",
  "pages.payment.expiresAt": "คำขอชำระเงินนี้หมดอายุเมื่อ {date}",
  "pages.payment.important": "สำคัญ:",
  "pages.payment.warningNetwork": "ส่ง USDT บนเครือข่ายนี้เท่านั้น!",
  "pages.payment.warningSendOnly": "• ส่ง USDT บนเครือข่าย {network} เท่านั้น",
  "pages.payment.warningLoss": "• การส่งโทเค็นอื่นหรือใช้เครือข่ายผิดอาจส่งผลให้สูญเสียถาวร",
  "pages.payment.warningExact": "• ส่งจำนวนที่แสดงด้านบนให้ถูกต้อง",
  "pages.payment.success.title": "ชำระเงินเสร็จสมบูรณ์!",
  "pages.payment.success.quotaAdded": "โควต้าของคุณถูกเพิ่มแล้วและไซต์ \"{siteName}\" กำลังถูกจัดเตรียม",
  "pages.payment.success.topupAdded": "เงินเติม ${amount} ของคุณถูกเพิ่มเข้ายอดคงเหลือแล้ว",
  "pages.payment.success.viewSites": "ดูไซต์ของฉัน",
  "pages.payment.success.close": "ปิด",
  "pages.payment.failed.title": "การเงินล้มเหลว",
  "pages.payment.failed.subtitle": "ไม่สามารถดำเนินการเงินได้ กรุณาลองใหม่อีกครั้ง",
  "pages.payment.failed.close": "ปิด",
  "pages.payment.error.create": "ไม่สามารถสร้างการเงินได้",
  "pages.payment.cancelled": "ยกเลิกการเงินแล้ว",
  "pages.settings.save": "บันทึกการเปลี่ยนแปลง",
  "pages.settings.reset": "รีเซ็ต",
  "pages.settings.apiConfig.saveSuccess": "บันทึกการตั้งค่า API สำเร็จ",
  "pages.settings.apiConfig.saveError": "ไม่สามารถบันทึกการตั้งค่า API ได้",
  "pages.settings.apiConfig.general": "ตั้งค่าทั่วไป",
  "pages.settings.apiConfig.authentication": "การตรวจสอบสิทธิ์",
  "pages.settings.apiConfig.baseURL": "URL หลัก",
  "pages.settings.apiConfig.timeout": "หมดเวลา (มิลลิวินาที)",
  "pages.settings.apiConfig.retryAttempts": "จำนวนครั้งที่ลองใหม่",
  "pages.settings.apiConfig.enableLogging": "เปิดใช้งานการบันทึก",
  "pages.settings.apiConfig.authType": "ประเภทการตรวจสอบสิทธิ์",
  "pages.settings.apiConfig.apiKey": "คีย์ API",
  "pages.settings.apiConfig.customHeaders": "ส่วนหัวที่กำหนดเอง (JSON)",
  "menu.settings.socialLinks": "Social Links",
  "pages.settings.socialLinks.saveSuccess": "บันทึกลิงก์โซเชียลสำเร็จ",
  "pages.settings.socialLinks.saveError": "ไม่สามารถบันทึกลิงก์โซเชียลได้",
  "pages.settings.socialLinks.title": "ลิงก์โซเชียลมีเดีย",
  "pages.settings.socialLinks.description": "เชื่อมต่อบัญชีโซเชียลมีเดียของคุณเพื่อแสดงในโปรไฟล์",
  "pages.settings.socialLinks.website": "เว็บไซต์",
  "pages.settings.socialLinks.facebook": "Facebook",
  "pages.settings.socialLinks.twitter": "Twitter / X",
  "pages.settings.socialLinks.instagram": "Instagram",
  "pages.settings.socialLinks.youtube": "YouTube",
  "pages.settings.socialLinks.linkedin": "LinkedIn",
  "pages.settings.socialLinks.github": "GitHub",
  "pages.settings.socialLinks.discord": "Discord",
  "pages.settings.socialLinks.telegram": "Telegram",
  "pages.settings.typography.saveSuccess": "บันทึกการตั้งค่าตัวอักษรสำเร็จ",
  "pages.settings.typography.saveError": "ไม่สามารถบันทึกการตั้งค่าตัวอักษรได้",
  "pages.settings.typography.fontSettings": "ตั้งค่าฟอนต์",
  "pages.settings.typography.fontFamily": "ครอบครัวฟอนต์",
  "pages.settings.typography.baseFontSize": "ขนาดฟอนต์พื้นฐาน (px)",
  "pages.settings.typography.lineHeight": "ความสูงบรรทัด",
  "pages.settings.typography.letterSpacing": "ระยะห่างตัวอักษร (px)",
  "pages.settings.typography.fontWeightNormal": "ความหนาปกติ",
  "pages.settings.typography.fontWeightBold": "ความหนาตัวหนา",
  "pages.settings.typography.colors": "สี",
  "pages.settings.typography.primaryColor": "สีหลัก",
  "pages.settings.typography.secondaryColor": "สีรอง",
  "pages.settings.typography.textColor": "สีตัวอักษร",
  "pages.settings.typography.preview": "ตัวอย่างสด",
  "player.detail.title": "รายละเอียดผู้เล่น",
  "player.detail.profile": "โปรไฟล์",
  "player.detail.nickname": "ชื่อเล่น",
  "player.detail.registeredAt": "วันที่สมัคร",
  "player.detail.phone": "เบอร์โทรศัพท์",
  "player.detail.affiliateFrom": "แนะนำจากโค้ด Affiliate",
  "player.detail.playerCountryCode": "ตั้งค่าภาษาหลัก",
  "player.detail.preferredCurrency": "สกุลเงินหลัก",
  "player.detail.uat": "UAT",
  "player.detail.creditBalance": "ยอดเงินคงเหลือ (1:USDT)",
  "player.detail.export": "ไฟล์",
  "player.detail.player.username": "ชื่อผู้ใช้",
  "player.detail.history.createdAt": "วันที่สร้าง",
  "player.detail.history.bonusName": "ชื่อโบนัส",
  "player.detail.history.source": "แหล่งที่มา",
  "player.detail.history.amount": "จำนวนเงิน",
  "player.detail.history.before": "ก่อน",
  "player.detail.history.after": "หลัง",
  "player.detail.history.bonus": "โบนัส",
  "player.detail.history.received": "ได้รับ",
  "player.detail.history.turnover": "ยอดเดิมพัน",
  "player.detail.history.status": "สถานะ",
  "player.detail.history.updatedBy": "อัปเดตโดย",
  "player.detail.withdrawInfo": "ข้อมูลการถอนเงิน",
  "player.detail.withdraw.date": "วันที่",
  "player.detail.withdraw.amount": "จำนวนเงิน",
  "player.detail.withdraw.bankName": "ธนาคาร",
  "player.detail.withdraw.accountNo": "หมายเลขบัญชี",
  "player.detail.withdraw.accountName": "ชื่อบัญชี",
  "player.detail.withdraw.source": "แหล่งที่มา",
  "player.detail.withdraw.note": "หมายเหตุ",
  "fund.status.completed": "เสร็จสมบูรณ์",
  "fund.status.pending": "รอดำเนินการ",
  "fund.status.processing": "กำลังดำเนินการ",
  "fund.status.failed": "ล้มเหลว",
  "fund.status.rejected": "ถูกปฏิเสธ",
  "fund.transactions.action.viewDetails": "ดูรายละเอียด",
  "fund.transactions.action.downloadReceipt": "ดาวน์โหลดใบเสร็จ",
  "fund.topup.modal.paymentRejected": "การเงินถูกปฏิเสธ",
  "fund.topup.modal.paymentRejectedMessage": "การเงินของคุณถูกปฏิเสธ กรุณาลองใหม่อีกครั้ง",
  "fund.topup.modal.close": "ปิด",
  "fund.topup.modal.creating": "กำลังสร้าง",
  "fund.topup.modal.payment": "ชำระเงิน",
  "fund.topup.modal.done": "เสร็จสิ้น",
  "fund.topup.modal.preparingAddress": "กำลังเตรียมที่อยู่ {cryptoLabel}...",
  "fund.topup.modal.autoConverted": "แปลงเป็น USDT อัตโนมัติ",
  "fund.topup.modal.copyAddress": "คัดลอกที่อยู่",
  "fund.topup.modal.copyExactAmount": "คัดลอกจำนวนเงิน {amount} {crypto}",
  "fund.topup.modal.expiresAt": "หมดอายุเมื่อ",
  "fund.topup.modal.sendOnly": "ส่ง {cryptoLabel} บน {networkLabel} เท่านั้น",
  "fund.topup.modal.paymentReceived": "ได้รับการเงินแล้ว!",
  "fund.topup.modal.paymentReceivedMessage": "{amount} USD ถูกแปลงเป็น USDT แล้ว",
  "fund.crypto.searchPlaceholder": "ค้นหาคริปโต (เช่น USDT, BTC, TRX...)",
  "fund.crypto.autoExchangeEnabled": "เปิดใช้การแลกเปลี่ยนอัตโนมัติ",
  "fund.crypto.autoExchangeNotice": "ของคุณจะถูกแปลงอัตโนมัติตามอัตราตลาดปัจจุบัน",
  "pages.game.category.all": "ทั้งหมด",
  "pages.redis.missingConfig": "ไม่พบการตั้งค่า Redis สำหรับไซต์นี้",
  "pages.redis.clientNotInitialized": "ไม่สามารถเชื่อมต่อ Redis ได้ กรุณาลองเปลี่ยนไซต์ใหม่",
  "brand.fetchError": "ดึงข้อมูลการตั้งค่าแบรนด์ไม่สำเร็จ",
  "brand.saveSuccess": "บันทึกการตั้งค่าแบรนด์สำเร็จ",
  "brand.saveError": "บันทึกการตั้งค่าแบรนด์ไม่สำเร็จ",
  "brand.social.saveSuccess": "บันทึกลิงก์โซเชียลมีเดียสำเร็จ",
  "brand.social.saveError": "บันทึกลิงก์โซเชียลมีเดียไม่สำเร็จ",
  "brand.manifest.saveSuccess": "บันทึกการตั้งค่า Manifest สำเร็จ",
  "brand.manifest.saveError": "บันทึกการตั้งค่า Manifest ไม่สำเร็จ",
  "brand.noSite": "ยังไม่ได้เลือกไซต์",
  "brand.noSite.desc": "กรุณาเลือกไซต์เพื่อจัดการการตั้งค่าแบรนด์และธีม",
  "brand.tab.design": "การออกแบบ",
  "brand.tab.social": "โซเชียลมีเดีย",
  "brand.tab.manifest": "PWA Manifest",
  "brand.tab.lobbies": "ทางเข้าไซต์ (Site Lobbies)",
  "brand.lobby.location": "ทางเข้าไซต์ (Site Lobbie)",
  "brand.lobby.maintenance": "ปิดปรับปรุง",
  "brand.lobbies.add": "ติดต่อผู้ดูแลระบบของคุณเพื่อเพิ่มทางเข้าไซต์",
  "brand.lobbies.add.subdomain": "เพิ่มซับโดเมนทางเข้า",
  "brand.lobbies.required": "กรุณาระบุทางเข้า",
  "brand.lobby.cname.title": "DOMAIN",
  "brand.lobby.cname.setup": "ตั้งค่า",
  "brand.lobby.cname.step1.title": "เข้าสู่ระบบผู้ให้บริการ DNS ของคุณ",
  "brand.lobby.cname.step1.desc": "เพิ่มระเบียน DOMAIN ต่อไปนี้:",
  "brand.lobby.cname.name": "ชื่อ",
  "brand.lobby.cname.target": "เป้าหมาย",
  "brand.lobby.cname.step2.title": "บันทึกการเปลี่ยนแปลงของคุณ",
  "brand.lobby.cname.step2.desc": "เมื่อคุณเพิ่มระเบียนแล้ว ตรวจสอบระเบียน DNS เพื่อเริ่มการตรวจสอบ",
  "brand.lobby.cname.checkDns": "ตรวจสอบระเบียน DNS",
  "brand.lobby.cname.note": "จะเปิดใช้งานโดยอัตโนมัติหากระเบียนของคุณถูกกำหนดค่าอย่างถูกต้อง การเปลี่ยนแปลง DNS ที่ผู้ให้บริการของคุณอาจใช้เวลาถึง 24 ชั่วโมงในการอัปเดตทั่วโลก",
  "brand.siteName": "ชื่อที่แสดงของเว็บไซต์",
  "brand.siteName.extra": "ชื่อสาธารณะของเว็บไซต์ของคุณ",
  "brand.logo": "โลโก้แบรนด์",
  "brand.logo.extra": "ขนาดที่แนะนำ: 512x512px (ไฟล์ PNG/WebP)",
  "brand.themeColor": "สีธีมหลัก (Primary)",
  "brand.themeColor.desc": "ปุ่มและการเน้นข้อความหลัก",
  "brand.secondaryColor": "สีธีมรอง (Secondary)",
  "brand.secondaryColor.desc": "สีรองสำหรับองค์ประกอบอื่นๆ",
  "brand.bgColor": "สีพื้นหลัง (Background)",
  "brand.bgColor.desc": "พื้นหลังหลักของเว็บไซต์ (--bg-color)",
  "brand.bgColorLobby": "สีพื้นหลังล็อบบี้",
  "brand.bgColorLobby.desc": "สีพื้นหลังสำหรับล็อบบี้ (--bg-color-lobby)",
  "brand.bgSidebar": "สีพื้นหลังแถบข้าง",
  "brand.bgSidebar.desc": "สีพื้นหลังแทบข้าง ซ้าย/ขวา (--bg-sidebar)",
  "brand.surfaceColor": "สีพื้นผิว (Surface)",
  "brand.surfaceColor.desc": "การ์ดและเลเยอร์ซ้อนทับ (--surface-color)",
  "brand.gameCardColor": "สีการ์ดเกม",
  "brand.gameCardColor.desc": "สีพื้นหลังสำหรับการ์ดเกม (--game-card-color)",
  "brand.bgCardColor": "สีพื้นหลังการ์ดแบบซ้อนทับ",
  "brand.bgCardColor.desc": "สีซ้อนทับสำหรับการ์ด (--bg-card-color)",
  "brand.textColor": "สีข้อความหลัก (Text Color)",
  "brand.textColor.desc": "สีข้อความหลักของเว็บไซต์ (--primary-text-color)",
  "brand.textSecondaryColor": "สีข้อความรอง",
  "brand.textSecondaryColor.desc": "สีรองสำหรับข้อความ (--foreground-secondary-color)",
  "brand.dividerColor": "สีเส้นคั่น",
  "brand.dividerColor.desc": "สีสำหรับเส้นคั่นระหว่างส่วนต่างๆ (--divider-color)",
  "brand.borderColor": "สีเส้นขอบ",
  "brand.borderColor.desc": "สีเส้นขอบของ Input และการ์ด (--border-color)",
  "brand.ringColor": "สีวงแหวนโฟกัส",
  "brand.ringColor.desc": "สีสำหรับสถานะโฟกัส (--ring-color)",
  "brand.accentColor": "สีเน้น (Accent)",
  "brand.accentColor.desc": "สีเน้นสำหรับส่วนประกอบพิเศษ (--accent-color)",
  "brand.textMuted": "สีข้อความจาง",
  "brand.textMuted.desc": "สีสำหรับคำอธิบายหรือข้อความที่ไม่สำคัญ (--text-muted)",
  "brand.textLightest": "สีข้อความขาวที่สุด",
  "brand.textLightest.desc": "สีขาวบริสุทธิ์สำหรับข้อความ (--text-lightest)",
  "brand.textLightest90": "สีข้อความขาว (90%)",
  "brand.textLightest90.desc": "สีขาวโปร่งแสงเล็กน้อย (--text-lightest-90)",
  "brand.bgActiveMenu": "สีพื้นหลังเมนูที่เลือก",
  "brand.bgActiveMenu.desc": "สีพื้นหลังสำหรับเมนู Sidebar ที่กำลังใช้งาน (--bg-active-menu-item)",
  "brand.secondaryDarker": "สีรองแบบเข้ม",
  "brand.secondaryDarker.desc": "สีรองเวอร์ชันที่เข้มกว่า (--secondary-darker)",
  "brand.background": "พื้นหลังกำหนดเอง",
  "brand.background.desc": "พื้นหลังไล่สีหรือสีพื้นกำหนดเอง (--brand-background)",
  "brand.lobby.featured_vendors": "ค่ายเกมแนะนำ",
  "brand.action": "ดำเนินการ",
  "brand.delete.confirm": "ยืนยันการลบรายการนี้หรือไม่?",
  "brand.category.manage": "จัดการหมวดหมู่เกม",
  "brand.customCss": "ตัวแปร Root ที่กำหนดเอง (CSS)",
  "brand.customCss.extra": "ใส่รหัส CSS (เช่น :root '{' --my-var: val; '}')",
  "brand.bgImage": "รูปภาพพื้นหลัง (Background Image)",
  "brand.bgImage.extra": "URL สำหรับรูปภาพพื้นหลังหรือ Mask ของเว็บไซต์",
  "brand.ogBanner": "รูปภาพแบนเนอร์ Meta OG",
  "brand.ogBanner.extra": "URL สำหรับรูปภาพแบนเนอร์ Open Graph (แนะนำ 1200x630)",
  "brand.bgSidebarImage": "รูปภาพพื้นหลังแถบข้าง",
  "brand.bgSidebarImage.extra": "URL สำหรับรูปภาพพื้นหลังแถบข้าง (แนะนำขนาด: 300x1080px ขึ้นไป)",
  "brand.blurSidebar": "เบลอแถบข้าง",
  "brand.blurSidebar.extra": "ใช้เอฟเฟกต์เบลอแบบ Glassmorphism กับแถบข้าง",
  "brand.showSiteTitle": "แสดงชื่อเว็บไซต์",
  "brand.showSiteTitle.extra": "แสดงชื่อเว็บไซต์ในแท็บเบราว์เซอร์และส่วนหัว",
  "brand.importTheme": "นำเข้าธีม",
  "brand.exportTheme": "ส่งออกธีม",
  "brand.save": "บันทึกการตั้งค่าดีไซน์",
  "brand.facebook": "Facebook",
  "brand.x": "X (Twitter)",
  "brand.telegram": "Telegram",
  "brand.whatsapp": "WhatsApp",
  "brand.line": "LINE",
  "manifest.name": "ชื่อแอป",
  "manifest.shortName": "ชื่อย่อ",
  "manifest.shortName.desc": "ใช้บนหน้าจอโฮมเมื่อพื้นที่จำกัด",
  "manifest.description": "คำอธิบาย",
  "manifest.display": "โหมดการแสดงผล",
  "manifest.orientation": "การวางแนวหน้าจอ",
  "manifest.themeColor": "สีธีม (PWA)",
  "manifest.backgroundColor": "สีพื้นหลัง (Splash)",
  "manifest.save": "บันทึกการตั้งค่า Manifest",
  "manifest.icons": "ไอคอนแอปพลิเคชัน",
  "manifest.screenshots": "ภาพหน้าจอ",
  "pages.xudo.deleteSuccess": "ลบสำเร็จแล้ว กำลังรีเฟรช...",
  "pages.xudo.deleteFailed": "ลบไม่สำเร็จ โปรดลองอีกครั้ง",
  "pages.xudo.addSuccess": "เพิ่มสำเร็จ",
  "pages.xudo.addFailed": "เพิ่มไม่สำเร็จ โปรดลองอีกครั้ง!",
  "pages.xudo.updateSuccess": "อัปเดตสำเร็จ",
  "pages.xudo.updateFailed": "อัปเดตไม่สำเร็จ โปรดลองอีกครั้ง",
  "pages.xudo.pleaseSelectItems": "โปรดเลือกรายการที่ต้องการลบ",
  "pages.xudo.game.selectGame": "โปรดเลือกเกม",
  "pages.account.binding.taobao": "ผูกบัญชี Taobao",
  "pages.account.binding.taobao.description": "ปัจจุบันยังไม่ได้ผูกบัญชี Taobao",
  "pages.account.binding.alxpay": "ผูกบัญชี Alxpay",
  "pages.account.binding.alxpay.description": "ปัจจุบันยังไม่ได้ผูกบัญชี Alxpay",
  "pages.account.binding.dingding": "ผูกบัญชี DingTalk",
  "pages.account.binding.dingding.description": "ปัจจุบันยังไม่ได้ผูกบัญชี DingTalk",
  "pages.account.binding.bind": "ผูกบัญชี",
  "pages.vendor.ggr.config.tier": "ระดับ {index}",
  "pages.account.security.strong": "แข็งแรง",
  "pages.account.security.medium": "ปานกลาง",
  "pages.account.security.weak": "อ่อนแอ",
  "pages.account.security.password": "รหัสผ่านบัญชี",
  "pages.account.security.password-description": "ระดับความปลอดภัยของรหัสผ่านปัจจุบัน:",
  "pages.account.security.phone": "เบอร์โทรศัพท์สำรอง",
  "pages.account.security.phone-description": "เบอร์โทรศัพท์ที่ผูกไว้:",
  "pages.account.security.question": "คำถามสำรอง",
  "pages.account.security.question-description": "ยังไม่ได้ตั้งคำถามสำรอง คำถามสำรองสามารถช่วยปกป้องความปลอดภัยของบัญชีได้อย่างมีประสิทธิภาพ",
  "pages.account.security.email": "อีเมลสำรอง",
  "pages.account.security.email-description": "อีเมลที่ผูกไว้:",
  "pages.account.security.mfa": "อุปกรณ์ MFA",
  "pages.account.security.mfa-description": "ยังไม่ได้ผูกอุปกรณ์ MFA หลังจากผูกแล้วสามารถทำการยืนยันตัวตนขั้นที่สองได้",
  "pages.account.security.modify": "แก้ไข",
  "pages.account.security.set": "ตั้งค่า",
  "pages.account.security.bind": "ผูกบัญชี",
  "pages.account.notification.user": "ข้อความจากผู้ใช้",
  "pages.account.notification.user-description": "ข้อความจากผู้ใช้รายอื่นจะได้รับการแจ้งเตือนในรูปแบบของจดหมายภายในเว็บไซต์",
  "pages.account.notification.system": "ข้อความจากระบบ",
  "pages.account.notification.system-description": "ข้อความจากระบบจะได้รับการแจ้งเตือนในรูปแบบของจดหมายภายในเว็บไซต์",
  "pages.account.notification.todo": "งานที่ต้องทำ",
  "pages.account.notification.todo-description": "งานที่ต้องทำจะได้รับการแจ้งเตือนในรูปแบบของจดหมายภายในเว็บไซต์",
  "pages.account.notification.on": "เปิด",
  "pages.account.notification.off": "ปิด",
  "pages.management.site-list.updateSuccess": "อัปเดตสำเร็จ",
  "pages.player.detail.tabs.deposit": "ประวัติการฝาก",
  "pages.player.detail.tabs.withdrawal": "ประวัติการถอน",
  "pages.player.detail.tabs.payout_accounts": "บัญชีรับเงิน",
  "pages.management.payment.title": "การจัดการการเงิน",
  "pages.management.payment.subTitle": "จัดการช่องทางการฝาก-ถอนเงิน",
  "pages.management.payment.table.channel": "ช่องทาง",
  "pages.management.payment.table.limits": "ขีดจำกัด",
  "pages.management.payment.table.min": "ขั้นต่ำ",
  "pages.management.payment.table.max": "สูงสุด",
  "pages.management.payment.table.fee": "ค่าธรรมเนียม",
  "pages.management.payment.table.availability": "ความพร้อมใช้งาน",
  "pages.management.payment.table.status": "สถานะ",
  "pages.management.payment.table.accountNo": "เลขที่บัญชี",
  "pages.management.payment.table.accountName": "ชื่อบัญชี",
  "pages.management.payment.status.online": "ระบบออนไลน์",
  "pages.management.payment.status.maintenance": "ปรับปรุงระบบ",
  "pages.management.payment.message.updateSuccess": "อัปเดตสถานะสำเร็จ",
  "pages.management.payment.message.updateFailed": "อัปเดตสถานะล้มเหลว",
  "pages.playerFinanceOperations.title": "ธุรกรรมที่กำลังดำเนินการ",
  "pages.playerFinanceOperations.filter.search": "ค้นหา",
  "pages.playerFinanceOperations.filter.searchPlaceholder": "REF, ผู้เล่น หรือเลขบัญชี",
  "pages.playerFinanceOperations.filter.type": "ประเภท",
  "pages.playerFinanceOperations.filter.dateTime": "วันเวลา",
  "pages.playerFinanceOperations.filter.status": "สถานะ",
  "pages.playerFinanceOperations.table.transaction": "รายการ",
  "pages.playerFinanceOperations.table.note": "หมายเหตุ",
  "pages.playerFinanceOperations.table.settledAt": "โอนสำเร็จ",
  "pages.playerFinanceOperations.type.deposit": "ฝาก",
  "pages.playerFinanceOperations.type.withdrawal": "ถอน",
  "pages.playerFinanceOperations.status.pending": "รอตรวจสอบ",
  "pages.playerFinanceOperations.status.settlement": "กำลังโอน",
  "pages.playerFinanceOperations.status.succeeded": "สำเร็จ",
  "pages.playerFinanceOperations.status.failed": "ล้มเหลว",
  "pages.playerFinanceOperations.status.cancelled": "ยกเลิก",
  "pages.playerFinanceOperations.status.expired": "หมดอายุ",
  "pages.common.placeholder.select": "โปรดเลือก...",
  "pages.common.placeholder.input": "โปรดระบุ...",
  "pages.common.search": "ค้นหา",
  "pages.common.submit": "ตกลง",
  "pages.common.reset": "ล้างข้อมูล",
  "pages.xudo.search.placeholder": "NEED_TRANSLATION",
  "pages.xudo.filter": "NEED_TRANSLATION",
  "pages.vendor.createdAt": "NEED_TRANSLATION",
  "pages.management.site-list.status.all": "NEED_TRANSLATION",
  "pages.management.site-list.status.supportRequired": "NEED_TRANSLATION",
  "pages.management.site-list.status.supportResolved": "NEED_TRANSLATION",
  "pages.management.site-list.createdAt": "NEED_TRANSLATION",
  "pages.management.site-manager.confirmDeduct": "NEED_TRANSLATION",
  "pages.management.players.createdAt": "NEED_TRANSLATION",
  "pages.xudo.xhub.form.apiPlaceholder": "NEED_TRANSLATION",
  "pages.xudo.xhub.form.seamlessPlaceholder": "NEED_TRANSLATION",
  "pages.xudo.xhub.form.healthCheckPlaceholder": "NEED_TRANSLATION",
  "pages.xudo.xhub.form.rawConfigTooltip": "NEED_TRANSLATION",
  "pages.org.rtm.title": "NEED_TRANSLATION",
  "pages.org.rtm.loading": "NEED_TRANSLATION",
  "pages.org.rtm.error.title": "NEED_TRANSLATION",
  "pages.org.rtm.error.description": "NEED_TRANSLATION",
  "pages.org.rtm.error.network": "NEED_TRANSLATION",
  "pages.org.rtm.error.server": "NEED_TRANSLATION",
  "pages.org.rtm.error.cors": "NEED_TRANSLATION",
  "pages.org.rtm.error.firewall": "NEED_TRANSLATION",
  "pages.org.rtm.retry": "NEED_TRANSLATION",
  "pages.org.rtm.attempt": "NEED_TRANSLATION",
  "pages.org.rtm.selectPlayer": "NEED_TRANSLATION",
  "pages.org.rtm.sessionId": "NEED_TRANSLATION",
  "pages.org.rtm.playerId": "NEED_TRANSLATION",
  "pages.org.rtm.gateway": "NEED_TRANSLATION",
  "pages.org.rtm.transactions": "NEED_TRANSLATION",
  "pages.org.rtm.liveData": "NEED_TRANSLATION",
  "pages.org.rtm.totalSessions": "NEED_TRANSLATION",
  "pages.org.rtm.playing": "NEED_TRANSLATION",
  "pages.org.rtm.idle": "NEED_TRANSLATION",
  "pages.org.rtm.creating": "NEED_TRANSLATION",
  "pages.org.rtm.refresh": "NEED_TRANSLATION",
  "pages.org.rtm.player": "NEED_TRANSLATION",
  "pages.org.rtm.balance": "NEED_TRANSLATION"
};
